/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as TenantRouteImport } from './routes/$tenant';
import { Route as CallbackRouteImport } from './routes/callback';
import { Route as LoginRouteImport } from './routes/login';
import { Route as SilentCallbackRouteImport } from './routes/silent-callback';
import { Route as TenantIndexRouteImport } from './routes/$tenant/index';
import { Route as TenantAgentsRouteImport } from './routes/$tenant/agents';
import { Route as TenantApiDocsRouteImport } from './routes/$tenant/api-docs';
import { Route as TenantAssistantRouteImport } from './routes/$tenant/assistant';
import { Route as TenantAuditRouteImport } from './routes/$tenant/audit';
import { Route as TenantAuditTrailRouteImport } from './routes/$tenant/audit-trail';
import { Route as TenantBrandingRouteImport } from './routes/$tenant/branding';
import { Route as TenantCodeAssistantRouteImport } from './routes/$tenant/code-assistant';
import { Route as TenantJupyterRouteImport } from './routes/$tenant/jupyter';
import { Route as TenantLlmKeysRouteImport } from './routes/$tenant/llm-keys';
import { Route as TenantMeRouteImport } from './routes/$tenant/me';
import { Route as TenantMfaRouteImport } from './routes/$tenant/mfa';
import { Route as TenantNotificationsRouteImport } from './routes/$tenant/notifications';
import { Route as TenantOverviewRouteImport } from './routes/$tenant/overview';
import { Route as TenantPreferencesRouteImport } from './routes/$tenant/preferences';
import { Route as TenantRstudioRouteImport } from './routes/$tenant/rstudio';
import { Route as TenantSearchRouteImport } from './routes/$tenant/search';
import { Route as TenantSecretStoreRouteImport } from './routes/$tenant/secret-store';
import { Route as TenantSubscriptionRouteImport } from './routes/$tenant/subscription';
import { Route as TenantUsageRouteImport } from './routes/$tenant/usage';
import { Route as TenantVscodeRouteImport } from './routes/$tenant/vscode';
import { Route as TenantAgentPoliciesIndexRouteImport } from './routes/$tenant/agent-policies/index';
import { Route as TenantAgentPoliciesPolicyIdRouteImport } from './routes/$tenant/agent-policies/$policyId';
import { Route as TenantAgentPoliciesNewRouteImport } from './routes/$tenant/agent-policies/new';
import { Route as TenantBillingIndexRouteImport } from './routes/$tenant/billing/index';
import { Route as TenantBillingPricingRouteImport } from './routes/$tenant/billing/pricing';
import { Route as TenantBridgesIndexRouteImport } from './routes/$tenant/bridges/index';
import { Route as TenantBridgesBridgeIdRouteImport } from './routes/$tenant/bridges/$bridgeId';
import { Route as TenantBridgesNewRouteImport } from './routes/$tenant/bridges/new';
import { Route as TenantBucketsIndexRouteImport } from './routes/$tenant/buckets/index';
import { Route as TenantBucketsBucketIdRouteImport } from './routes/$tenant/buckets/$bucketId';
import { Route as TenantBucketsNewRouteImport } from './routes/$tenant/buckets/new';
import { Route as TenantCatalogIndexRouteImport } from './routes/$tenant/catalog/index';
import { Route as TenantCatalogNewRouteImport } from './routes/$tenant/catalog/new';
import { Route as TenantConnectionsIndexRouteImport } from './routes/$tenant/connections/index';
import { Route as TenantEditorIndexRouteImport } from './routes/$tenant/editor/index';
import { Route as TenantEditorGraphIdRouteImport } from './routes/$tenant/editor/$graphId';
import { Route as TenantEditorNewRouteImport } from './routes/$tenant/editor/new';
import { Route as TenantEndpointsIndexRouteImport } from './routes/$tenant/endpoints/index';
import { Route as TenantExperimentsIndexRouteImport } from './routes/$tenant/experiments/index';
import { Route as TenantFirewallIndexRouteImport } from './routes/$tenant/firewall/index';
import { Route as TenantFirewallRuleIdRouteImport } from './routes/$tenant/firewall/$ruleId';
import { Route as TenantFirewallNewRouteImport } from './routes/$tenant/firewall/new';
import { Route as TenantGlossaryIndexRouteImport } from './routes/$tenant/glossary/index';
import { Route as TenantGlossaryTermIdRouteImport } from './routes/$tenant/glossary/$termId';
import { Route as TenantGlossaryNewRouteImport } from './routes/$tenant/glossary/new';
import { Route as TenantGroupsIndexRouteImport } from './routes/$tenant/groups/index';
import { Route as TenantGroupsGroupIdRouteImport } from './routes/$tenant/groups/$groupId';
import { Route as TenantGroupsNewRouteImport } from './routes/$tenant/groups/new';
import { Route as TenantIdentityProvidersIndexRouteImport } from './routes/$tenant/identity-providers/index';
import { Route as TenantIdentityProvidersIdentityProviderIdRouteImport } from './routes/$tenant/identity-providers/$identityProviderId';
import { Route as TenantIdentityProvidersNewRouteImport } from './routes/$tenant/identity-providers/new';
import { Route as TenantJobsIndexRouteImport } from './routes/$tenant/jobs/index';
import { Route as TenantLibrariesIndexRouteImport } from './routes/$tenant/libraries/index';
import { Route as TenantLineageIndexRouteImport } from './routes/$tenant/lineage/index';
import { Route as TenantLineageGraphRouteImport } from './routes/$tenant/lineage/graph';
import { Route as TenantLlmIndexRouteImport } from './routes/$tenant/llm/index';
import { Route as TenantMembersIndexRouteImport } from './routes/$tenant/members/index';
import { Route as TenantMembersUserIdRouteImport } from './routes/$tenant/members/$userId';
import { Route as TenantMembersNewRouteImport } from './routes/$tenant/members/new';
import { Route as TenantModelsIndexRouteImport } from './routes/$tenant/models/index';
import { Route as TenantModelsNewRouteImport } from './routes/$tenant/models/new';
import { Route as TenantProjectsIndexRouteImport } from './routes/$tenant/projects/index';
import { Route as TenantProjectsNewRouteImport } from './routes/$tenant/projects/new';
import { Route as TenantRolesIndexRouteImport } from './routes/$tenant/roles/index';
import { Route as TenantRolesRoleIdRouteImport } from './routes/$tenant/roles/$roleId';
import { Route as TenantRolesAssignmentsRouteImport } from './routes/$tenant/roles/assignments';
import { Route as TenantRolesNewRouteImport } from './routes/$tenant/roles/new';
import { Route as TenantRuntimesIndexRouteImport } from './routes/$tenant/runtimes/index';
import { Route as TenantRuntimesNewRouteImport } from './routes/$tenant/runtimes/new';
import { Route as TenantSecretsIndexRouteImport } from './routes/$tenant/secrets/index';
import { Route as TenantSecretsSecretIdRouteImport } from './routes/$tenant/secrets/$secretId';
import { Route as TenantSecretsNewRouteImport } from './routes/$tenant/secrets/new';
import { Route as TenantSessionsIndexRouteImport } from './routes/$tenant/sessions/index';
import { Route as TenantSessionsSessionIdRouteImport } from './routes/$tenant/sessions/$sessionId';
import { Route as TenantSessionsNewRouteImport } from './routes/$tenant/sessions/new';
import { Route as TenantSqlIndexRouteImport } from './routes/$tenant/sql/index';
import { Route as TenantSqlNewRouteImport } from './routes/$tenant/sql/new';
import { Route as TenantStreamsIndexRouteImport } from './routes/$tenant/streams/index';
import { Route as TenantStreamsStreamIdRouteImport } from './routes/$tenant/streams/$streamId';
import { Route as TenantStreamsNewRouteImport } from './routes/$tenant/streams/new';
import { Route as TenantSupportIndexRouteImport } from './routes/$tenant/support/index';
import { Route as TenantSupportTicketIdRouteImport } from './routes/$tenant/support/$ticketId';
import { Route as TenantSupportNewRouteImport } from './routes/$tenant/support/new';
import { Route as TenantTokensIndexRouteImport } from './routes/$tenant/tokens/index';
import { Route as TenantTokensNewRouteImport } from './routes/$tenant/tokens/new';
import { Route as TenantTriggersIndexRouteImport } from './routes/$tenant/triggers/index';
import { Route as TenantWorkflowsIndexRouteImport } from './routes/$tenant/workflows/index';
import { Route as TenantWorkflowsEditorRouteImport } from './routes/$tenant/workflows/editor';
import { Route as TenantWorkspacesIndexRouteImport } from './routes/$tenant/workspaces/index';
import { Route as TenantWorkspacesWorkspaceIdRouteImport } from './routes/$tenant/workspaces/$workspaceId';
import { Route as TenantWorkspacesNewRouteImport } from './routes/$tenant/workspaces/new';
import { Route as TenantBillingInvoicesIndexRouteImport } from './routes/$tenant/billing/invoices/index';
import { Route as TenantBillingInvoicesInvoiceIdRouteImport } from './routes/$tenant/billing/invoices/$invoiceId';
import { Route as TenantBillingPaymentMethodsIndexRouteImport } from './routes/$tenant/billing/payment-methods/index';
import { Route as TenantBillingPaymentMethodsNewRouteImport } from './routes/$tenant/billing/payment-methods/new';
import { Route as TenantBillingTransactionsIndexRouteImport } from './routes/$tenant/billing/transactions/index';
import { Route as TenantBillingTransactionsTransactionIdRouteImport } from './routes/$tenant/billing/transactions/$transactionId';
import { Route as TenantCatalogLayerIndexRouteImport } from './routes/$tenant/catalog/$layer/index';
import { Route as TenantCatalogLayerNewRouteImport } from './routes/$tenant/catalog/$layer/new';
import { Route as TenantEditorTemplatesIndexRouteImport } from './routes/$tenant/editor/templates/index';
import { Route as TenantEditorTemplatesTemplateNameRouteImport } from './routes/$tenant/editor/templates/$templateName';
import { Route as TenantLlmBudgetsProjectIdRouteImport } from './routes/$tenant/llm/budgets/$projectId';
import { Route as TenantLlmModelsModelIdRouteImport } from './routes/$tenant/llm/models/$modelId';
import { Route as TenantLlmModelsNewRouteImport } from './routes/$tenant/llm/models/new';
import { Route as TenantLlmProvidersProviderIdRouteImport } from './routes/$tenant/llm/providers/$providerId';
import { Route as TenantLlmProvidersNewRouteImport } from './routes/$tenant/llm/providers/new';
import { Route as TenantModelsModelIdIndexRouteImport } from './routes/$tenant/models/$modelId/index';
import { Route as TenantProjectsProjectIdIndexRouteImport } from './routes/$tenant/projects/$projectId/index';
import { Route as TenantProjectsProjectIdActivityRouteImport } from './routes/$tenant/projects/$projectId/activity';
import { Route as TenantProjectsProjectIdAgentsRouteImport } from './routes/$tenant/projects/$projectId/agents';
import { Route as TenantProjectsProjectIdCodeAssistantRouteImport } from './routes/$tenant/projects/$projectId/code-assistant';
import { Route as TenantProjectsProjectIdCostsRouteImport } from './routes/$tenant/projects/$projectId/costs';
import { Route as TenantProjectsProjectIdLlmKeysRouteImport } from './routes/$tenant/projects/$projectId/llm-keys';
import { Route as TenantProjectsProjectIdMetricsRouteImport } from './routes/$tenant/projects/$projectId/metrics';
import { Route as TenantProjectsProjectIdSettingsRouteImport } from './routes/$tenant/projects/$projectId/settings';
import { Route as TenantResourcesDevicesIndexRouteImport } from './routes/$tenant/resources/devices/index';
import { Route as TenantResourcesDevicesDeviceIdRouteImport } from './routes/$tenant/resources/devices/$deviceId';
import { Route as TenantResourcesDevicesEnrollRouteImport } from './routes/$tenant/resources/devices/enroll';
import { Route as TenantResourcesInfrastructuresIndexRouteImport } from './routes/$tenant/resources/infrastructures/index';
import { Route as TenantResourcesInfrastructuresInfrastructureIdRouteImport } from './routes/$tenant/resources/infrastructures/$infrastructureId';
import { Route as TenantResourcesInfrastructuresNewRouteImport } from './routes/$tenant/resources/infrastructures/new';
import { Route as TenantResourcesInstanceTypesIndexRouteImport } from './routes/$tenant/resources/instance-types/index';
import { Route as TenantResourcesInstanceTypesInstanceTypeIdRouteImport } from './routes/$tenant/resources/instance-types/$instanceTypeId';
import { Route as TenantResourcesQuotasIndexRouteImport } from './routes/$tenant/resources/quotas/index';
import { Route as TenantResourcesQuotasQuotaKeyRouteImport } from './routes/$tenant/resources/quotas/$quotaKey';
import { Route as TenantRuntimesRuntimeIdIndexRouteImport } from './routes/$tenant/runtimes/$runtimeId/index';
import { Route as TenantSqlWarehouseIdIndexRouteImport } from './routes/$tenant/sql/$warehouseId/index';
import { Route as TenantSqlWarehouseIdQueryRouteImport } from './routes/$tenant/sql/$warehouseId/query';
import { Route as TenantTokensAgentsIdentityIdRouteImport } from './routes/$tenant/tokens/agents/$identityId';
import { Route as TenantTokensApiApplicationIdRouteImport } from './routes/$tenant/tokens/api/$applicationId';
import { Route as TenantCatalogLayerDatabaseIndexRouteImport } from './routes/$tenant/catalog/$layer/$database/index';
import { Route as TenantCatalogLayerDatabaseNewRouteImport } from './routes/$tenant/catalog/$layer/$database/new';
import { Route as TenantJobsJobIdRunsRunIdRouteImport } from './routes/$tenant/jobs/$jobId/runs/$runId';
import { Route as TenantModelsModelIdVersionsVersionIdRouteImport } from './routes/$tenant/models/$modelId/versions/$versionId';
import { Route as TenantModelsModelIdVersionsNewRouteImport } from './routes/$tenant/models/$modelId/versions/new';
import { Route as TenantProjectsProjectIdApprovalsApprovalIdRouteImport } from './routes/$tenant/projects/$projectId/approvals/$approvalId';
import { Route as TenantProjectsProjectIdAssistantIndexRouteImport } from './routes/$tenant/projects/$projectId/assistant/index';
import { Route as TenantProjectsProjectIdAssistantIndexIdRouteImport } from './routes/$tenant/projects/$projectId/assistant/$indexId';
import { Route as TenantProjectsProjectIdAssistantNewRouteImport } from './routes/$tenant/projects/$projectId/assistant/new';
import { Route as TenantProjectsProjectIdConnectionsIndexRouteImport } from './routes/$tenant/projects/$projectId/connections/index';
import { Route as TenantProjectsProjectIdConnectionsConnectionIdRouteImport } from './routes/$tenant/projects/$projectId/connections/$connectionId';
import { Route as TenantProjectsProjectIdConnectionsNewRouteImport } from './routes/$tenant/projects/$projectId/connections/new';
import { Route as TenantProjectsProjectIdEndpointsIndexRouteImport } from './routes/$tenant/projects/$projectId/endpoints/index';
import { Route as TenantProjectsProjectIdEndpointsEndpointIdRouteImport } from './routes/$tenant/projects/$projectId/endpoints/$endpointId';
import { Route as TenantProjectsProjectIdEndpointsNewRouteImport } from './routes/$tenant/projects/$projectId/endpoints/new';
import { Route as TenantProjectsProjectIdExperimentsIndexRouteImport } from './routes/$tenant/projects/$projectId/experiments/index';
import { Route as TenantProjectsProjectIdExperimentsNewRouteImport } from './routes/$tenant/projects/$projectId/experiments/new';
import { Route as TenantProjectsProjectIdJobsIndexRouteImport } from './routes/$tenant/projects/$projectId/jobs/index';
import { Route as TenantProjectsProjectIdJobsNewRouteImport } from './routes/$tenant/projects/$projectId/jobs/new';
import { Route as TenantProjectsProjectIdMembersIndexRouteImport } from './routes/$tenant/projects/$projectId/members/index';
import { Route as TenantProjectsProjectIdMembersNewRouteImport } from './routes/$tenant/projects/$projectId/members/new';
import { Route as TenantProjectsProjectIdTriggersIndexRouteImport } from './routes/$tenant/projects/$projectId/triggers/index';
import { Route as TenantProjectsProjectIdWorkflowsIndexRouteImport } from './routes/$tenant/projects/$projectId/workflows/index';
import { Route as TenantProjectsProjectIdWorkflowsEditorRouteImport } from './routes/$tenant/projects/$projectId/workflows/editor';
import { Route as TenantProjectsProjectIdWorkflowsImportOozieRouteImport } from './routes/$tenant/projects/$projectId/workflows/import-oozie';
import { Route as TenantProjectsProjectIdWorkflowsNewRouteImport } from './routes/$tenant/projects/$projectId/workflows/new';
import { Route as TenantRuntimesRuntimeIdBuildsBuildIdRouteImport } from './routes/$tenant/runtimes/$runtimeId/builds/$buildId';
import { Route as TenantRuntimesRuntimeIdBuildsNewRouteImport } from './routes/$tenant/runtimes/$runtimeId/builds/new';
import { Route as TenantRuntimesRuntimeIdVersionsVersionIdRouteImport } from './routes/$tenant/runtimes/$runtimeId/versions/$versionId';
import { Route as TenantRuntimesRuntimeIdVersionsNewRouteImport } from './routes/$tenant/runtimes/$runtimeId/versions/new';
import { Route as TenantCatalogLayerDatabaseTableIndexRouteImport } from './routes/$tenant/catalog/$layer/$database/$table/index';
import { Route as TenantCatalogLayerDatabaseTableFieldRouteImport } from './routes/$tenant/catalog/$layer/$database/$table/$field';
import { Route as TenantCatalogLayerDatabaseTableNewRouteImport } from './routes/$tenant/catalog/$layer/$database/$table/new';
import { Route as TenantProjectsProjectIdExperimentsExperimentIdIndexRouteImport } from './routes/$tenant/projects/$projectId/experiments/$experimentId/index';
import { Route as TenantProjectsProjectIdExperimentsExperimentIdCompareRouteImport } from './routes/$tenant/projects/$projectId/experiments/$experimentId/compare';
import { Route as TenantProjectsProjectIdJobsJobIdIndexRouteImport } from './routes/$tenant/projects/$projectId/jobs/$jobId/index';
import { Route as TenantProjectsProjectIdWorkflowsWorkflowIdIndexRouteImport } from './routes/$tenant/projects/$projectId/workflows/$workflowId/index';
import { Route as TenantProjectsProjectIdWorkflowsWorkflowIdEditorRouteImport } from './routes/$tenant/projects/$projectId/workflows/$workflowId/editor';
import { Route as TenantProjectsProjectIdExperimentsExperimentIdRunsRunIdRouteImport } from './routes/$tenant/projects/$projectId/experiments/$experimentId/runs/$runId';
import { Route as TenantProjectsProjectIdJobsJobIdRunsRunIdRouteImport } from './routes/$tenant/projects/$projectId/jobs/$jobId/runs/$runId';
import { Route as TenantProjectsProjectIdWorkflowsWorkflowIdRunsRunIdRouteImport } from './routes/$tenant/projects/$projectId/workflows/$workflowId/runs/$runId';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const TenantRoute = TenantRouteImport.update({
  id: '/$tenant',
  path: '/$tenant',
  getParentRoute: () => rootRouteImport,
} as any);
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const SilentCallbackRoute = SilentCallbackRouteImport.update({
  id: '/silent-callback',
  path: '/silent-callback',
  getParentRoute: () => rootRouteImport,
} as any);
const TenantIndexRoute = TenantIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantAgentsRoute = TenantAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => TenantRoute,
} as any);
const TenantApiDocsRoute = TenantApiDocsRouteImport.update({
  id: '/api-docs',
  path: '/api-docs',
  getParentRoute: () => TenantRoute,
} as any);
const TenantAssistantRoute = TenantAssistantRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => TenantRoute,
} as any);
const TenantAuditRoute = TenantAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => TenantRoute,
} as any);
const TenantAuditTrailRoute = TenantAuditTrailRouteImport.update({
  id: '/audit-trail',
  path: '/audit-trail',
  getParentRoute: () => TenantRoute,
} as any);
const TenantBrandingRoute = TenantBrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => TenantRoute,
} as any);
const TenantCodeAssistantRoute = TenantCodeAssistantRouteImport.update({
  id: '/code-assistant',
  path: '/code-assistant',
  getParentRoute: () => TenantRoute,
} as any);
const TenantJupyterRoute = TenantJupyterRouteImport.update({
  id: '/jupyter',
  path: '/jupyter',
  getParentRoute: () => TenantRoute,
} as any);
const TenantLlmKeysRoute = TenantLlmKeysRouteImport.update({
  id: '/llm-keys',
  path: '/llm-keys',
  getParentRoute: () => TenantRoute,
} as any);
const TenantMeRoute = TenantMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => TenantRoute,
} as any);
const TenantMfaRoute = TenantMfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => TenantRoute,
} as any);
const TenantNotificationsRoute = TenantNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => TenantRoute,
} as any);
const TenantOverviewRoute = TenantOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => TenantRoute,
} as any);
const TenantPreferencesRoute = TenantPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => TenantRoute,
} as any);
const TenantRstudioRoute = TenantRstudioRouteImport.update({
  id: '/rstudio',
  path: '/rstudio',
  getParentRoute: () => TenantRoute,
} as any);
const TenantSearchRoute = TenantSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => TenantRoute,
} as any);
const TenantSecretStoreRoute = TenantSecretStoreRouteImport.update({
  id: '/secret-store',
  path: '/secret-store',
  getParentRoute: () => TenantRoute,
} as any);
const TenantSubscriptionRoute = TenantSubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => TenantRoute,
} as any);
const TenantUsageRoute = TenantUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => TenantRoute,
} as any);
const TenantVscodeRoute = TenantVscodeRouteImport.update({
  id: '/vscode',
  path: '/vscode',
  getParentRoute: () => TenantRoute,
} as any);
const TenantAgentPoliciesIndexRoute =
  TenantAgentPoliciesIndexRouteImport.update({
    id: '/agent-policies/',
    path: '/agent-policies/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantAgentPoliciesPolicyIdRoute =
  TenantAgentPoliciesPolicyIdRouteImport.update({
    id: '/agent-policies/$policyId',
    path: '/agent-policies/$policyId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantAgentPoliciesNewRoute = TenantAgentPoliciesNewRouteImport.update({
  id: '/agent-policies/new',
  path: '/agent-policies/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantBillingIndexRoute = TenantBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantBillingPricingRoute = TenantBillingPricingRouteImport.update({
  id: '/billing/pricing',
  path: '/billing/pricing',
  getParentRoute: () => TenantRoute,
} as any);
const TenantBridgesIndexRoute = TenantBridgesIndexRouteImport.update({
  id: '/bridges/',
  path: '/bridges/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantBridgesBridgeIdRoute = TenantBridgesBridgeIdRouteImport.update({
  id: '/bridges/$bridgeId',
  path: '/bridges/$bridgeId',
  getParentRoute: () => TenantRoute,
} as any);
const TenantBridgesNewRoute = TenantBridgesNewRouteImport.update({
  id: '/bridges/new',
  path: '/bridges/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantBucketsIndexRoute = TenantBucketsIndexRouteImport.update({
  id: '/buckets/',
  path: '/buckets/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantBucketsBucketIdRoute = TenantBucketsBucketIdRouteImport.update({
  id: '/buckets/$bucketId',
  path: '/buckets/$bucketId',
  getParentRoute: () => TenantRoute,
} as any);
const TenantBucketsNewRoute = TenantBucketsNewRouteImport.update({
  id: '/buckets/new',
  path: '/buckets/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantCatalogIndexRoute = TenantCatalogIndexRouteImport.update({
  id: '/catalog/',
  path: '/catalog/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantCatalogNewRoute = TenantCatalogNewRouteImport.update({
  id: '/catalog/new',
  path: '/catalog/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantConnectionsIndexRoute = TenantConnectionsIndexRouteImport.update({
  id: '/connections/',
  path: '/connections/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantEditorIndexRoute = TenantEditorIndexRouteImport.update({
  id: '/editor/',
  path: '/editor/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantEditorGraphIdRoute = TenantEditorGraphIdRouteImport.update({
  id: '/editor/$graphId',
  path: '/editor/$graphId',
  getParentRoute: () => TenantRoute,
} as any);
const TenantEditorNewRoute = TenantEditorNewRouteImport.update({
  id: '/editor/new',
  path: '/editor/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantEndpointsIndexRoute = TenantEndpointsIndexRouteImport.update({
  id: '/endpoints/',
  path: '/endpoints/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantExperimentsIndexRoute = TenantExperimentsIndexRouteImport.update({
  id: '/experiments/',
  path: '/experiments/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantFirewallIndexRoute = TenantFirewallIndexRouteImport.update({
  id: '/firewall/',
  path: '/firewall/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantFirewallRuleIdRoute = TenantFirewallRuleIdRouteImport.update({
  id: '/firewall/$ruleId',
  path: '/firewall/$ruleId',
  getParentRoute: () => TenantRoute,
} as any);
const TenantFirewallNewRoute = TenantFirewallNewRouteImport.update({
  id: '/firewall/new',
  path: '/firewall/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantGlossaryIndexRoute = TenantGlossaryIndexRouteImport.update({
  id: '/glossary/',
  path: '/glossary/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantGlossaryTermIdRoute = TenantGlossaryTermIdRouteImport.update({
  id: '/glossary/$termId',
  path: '/glossary/$termId',
  getParentRoute: () => TenantRoute,
} as any);
const TenantGlossaryNewRoute = TenantGlossaryNewRouteImport.update({
  id: '/glossary/new',
  path: '/glossary/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantGroupsIndexRoute = TenantGroupsIndexRouteImport.update({
  id: '/groups/',
  path: '/groups/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantGroupsGroupIdRoute = TenantGroupsGroupIdRouteImport.update({
  id: '/groups/$groupId',
  path: '/groups/$groupId',
  getParentRoute: () => TenantRoute,
} as any);
const TenantGroupsNewRoute = TenantGroupsNewRouteImport.update({
  id: '/groups/new',
  path: '/groups/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantIdentityProvidersIndexRoute =
  TenantIdentityProvidersIndexRouteImport.update({
    id: '/identity-providers/',
    path: '/identity-providers/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantIdentityProvidersIdentityProviderIdRoute =
  TenantIdentityProvidersIdentityProviderIdRouteImport.update({
    id: '/identity-providers/$identityProviderId',
    path: '/identity-providers/$identityProviderId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantIdentityProvidersNewRoute =
  TenantIdentityProvidersNewRouteImport.update({
    id: '/identity-providers/new',
    path: '/identity-providers/new',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantJobsIndexRoute = TenantJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantLibrariesIndexRoute = TenantLibrariesIndexRouteImport.update({
  id: '/libraries/',
  path: '/libraries/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantLineageIndexRoute = TenantLineageIndexRouteImport.update({
  id: '/lineage/',
  path: '/lineage/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantLineageGraphRoute = TenantLineageGraphRouteImport.update({
  id: '/lineage/graph',
  path: '/lineage/graph',
  getParentRoute: () => TenantRoute,
} as any);
const TenantLlmIndexRoute = TenantLlmIndexRouteImport.update({
  id: '/llm/',
  path: '/llm/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantMembersIndexRoute = TenantMembersIndexRouteImport.update({
  id: '/members/',
  path: '/members/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantMembersUserIdRoute = TenantMembersUserIdRouteImport.update({
  id: '/members/$userId',
  path: '/members/$userId',
  getParentRoute: () => TenantRoute,
} as any);
const TenantMembersNewRoute = TenantMembersNewRouteImport.update({
  id: '/members/new',
  path: '/members/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantModelsIndexRoute = TenantModelsIndexRouteImport.update({
  id: '/models/',
  path: '/models/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantModelsNewRoute = TenantModelsNewRouteImport.update({
  id: '/models/new',
  path: '/models/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantProjectsIndexRoute = TenantProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantProjectsNewRoute = TenantProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantRolesIndexRoute = TenantRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantRolesRoleIdRoute = TenantRolesRoleIdRouteImport.update({
  id: '/roles/$roleId',
  path: '/roles/$roleId',
  getParentRoute: () => TenantRoute,
} as any);
const TenantRolesAssignmentsRoute = TenantRolesAssignmentsRouteImport.update({
  id: '/roles/assignments',
  path: '/roles/assignments',
  getParentRoute: () => TenantRoute,
} as any);
const TenantRolesNewRoute = TenantRolesNewRouteImport.update({
  id: '/roles/new',
  path: '/roles/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantRuntimesIndexRoute = TenantRuntimesIndexRouteImport.update({
  id: '/runtimes/',
  path: '/runtimes/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantRuntimesNewRoute = TenantRuntimesNewRouteImport.update({
  id: '/runtimes/new',
  path: '/runtimes/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantSecretsIndexRoute = TenantSecretsIndexRouteImport.update({
  id: '/secrets/',
  path: '/secrets/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantSecretsSecretIdRoute = TenantSecretsSecretIdRouteImport.update({
  id: '/secrets/$secretId',
  path: '/secrets/$secretId',
  getParentRoute: () => TenantRoute,
} as any);
const TenantSecretsNewRoute = TenantSecretsNewRouteImport.update({
  id: '/secrets/new',
  path: '/secrets/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantSessionsIndexRoute = TenantSessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantSessionsSessionIdRoute = TenantSessionsSessionIdRouteImport.update({
  id: '/sessions/$sessionId',
  path: '/sessions/$sessionId',
  getParentRoute: () => TenantRoute,
} as any);
const TenantSessionsNewRoute = TenantSessionsNewRouteImport.update({
  id: '/sessions/new',
  path: '/sessions/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantSqlIndexRoute = TenantSqlIndexRouteImport.update({
  id: '/sql/',
  path: '/sql/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantSqlNewRoute = TenantSqlNewRouteImport.update({
  id: '/sql/new',
  path: '/sql/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantStreamsIndexRoute = TenantStreamsIndexRouteImport.update({
  id: '/streams/',
  path: '/streams/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantStreamsStreamIdRoute = TenantStreamsStreamIdRouteImport.update({
  id: '/streams/$streamId',
  path: '/streams/$streamId',
  getParentRoute: () => TenantRoute,
} as any);
const TenantStreamsNewRoute = TenantStreamsNewRouteImport.update({
  id: '/streams/new',
  path: '/streams/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantSupportIndexRoute = TenantSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantSupportTicketIdRoute = TenantSupportTicketIdRouteImport.update({
  id: '/support/$ticketId',
  path: '/support/$ticketId',
  getParentRoute: () => TenantRoute,
} as any);
const TenantSupportNewRoute = TenantSupportNewRouteImport.update({
  id: '/support/new',
  path: '/support/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantTokensIndexRoute = TenantTokensIndexRouteImport.update({
  id: '/tokens/',
  path: '/tokens/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantTokensNewRoute = TenantTokensNewRouteImport.update({
  id: '/tokens/new',
  path: '/tokens/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantTriggersIndexRoute = TenantTriggersIndexRouteImport.update({
  id: '/triggers/',
  path: '/triggers/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantWorkflowsIndexRoute = TenantWorkflowsIndexRouteImport.update({
  id: '/workflows/',
  path: '/workflows/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantWorkflowsEditorRoute = TenantWorkflowsEditorRouteImport.update({
  id: '/workflows/editor',
  path: '/workflows/editor',
  getParentRoute: () => TenantRoute,
} as any);
const TenantWorkspacesIndexRoute = TenantWorkspacesIndexRouteImport.update({
  id: '/workspaces/',
  path: '/workspaces/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantWorkspacesWorkspaceIdRoute =
  TenantWorkspacesWorkspaceIdRouteImport.update({
    id: '/workspaces/$workspaceId',
    path: '/workspaces/$workspaceId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantWorkspacesNewRoute = TenantWorkspacesNewRouteImport.update({
  id: '/workspaces/new',
  path: '/workspaces/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantBillingInvoicesIndexRoute =
  TenantBillingInvoicesIndexRouteImport.update({
    id: '/billing/invoices/',
    path: '/billing/invoices/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantBillingInvoicesInvoiceIdRoute =
  TenantBillingInvoicesInvoiceIdRouteImport.update({
    id: '/billing/invoices/$invoiceId',
    path: '/billing/invoices/$invoiceId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantBillingPaymentMethodsIndexRoute =
  TenantBillingPaymentMethodsIndexRouteImport.update({
    id: '/billing/payment-methods/',
    path: '/billing/payment-methods/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantBillingPaymentMethodsNewRoute =
  TenantBillingPaymentMethodsNewRouteImport.update({
    id: '/billing/payment-methods/new',
    path: '/billing/payment-methods/new',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantBillingTransactionsIndexRoute =
  TenantBillingTransactionsIndexRouteImport.update({
    id: '/billing/transactions/',
    path: '/billing/transactions/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantBillingTransactionsTransactionIdRoute =
  TenantBillingTransactionsTransactionIdRouteImport.update({
    id: '/billing/transactions/$transactionId',
    path: '/billing/transactions/$transactionId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantCatalogLayerIndexRoute = TenantCatalogLayerIndexRouteImport.update({
  id: '/catalog/$layer/',
  path: '/catalog/$layer/',
  getParentRoute: () => TenantRoute,
} as any);
const TenantCatalogLayerNewRoute = TenantCatalogLayerNewRouteImport.update({
  id: '/catalog/$layer/new',
  path: '/catalog/$layer/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantEditorTemplatesIndexRoute =
  TenantEditorTemplatesIndexRouteImport.update({
    id: '/editor/templates/',
    path: '/editor/templates/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantEditorTemplatesTemplateNameRoute =
  TenantEditorTemplatesTemplateNameRouteImport.update({
    id: '/editor/templates/$templateName',
    path: '/editor/templates/$templateName',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantLlmBudgetsProjectIdRoute =
  TenantLlmBudgetsProjectIdRouteImport.update({
    id: '/llm/budgets/$projectId',
    path: '/llm/budgets/$projectId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantLlmModelsModelIdRoute = TenantLlmModelsModelIdRouteImport.update({
  id: '/llm/models/$modelId',
  path: '/llm/models/$modelId',
  getParentRoute: () => TenantRoute,
} as any);
const TenantLlmModelsNewRoute = TenantLlmModelsNewRouteImport.update({
  id: '/llm/models/new',
  path: '/llm/models/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantLlmProvidersProviderIdRoute =
  TenantLlmProvidersProviderIdRouteImport.update({
    id: '/llm/providers/$providerId',
    path: '/llm/providers/$providerId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantLlmProvidersNewRoute = TenantLlmProvidersNewRouteImport.update({
  id: '/llm/providers/new',
  path: '/llm/providers/new',
  getParentRoute: () => TenantRoute,
} as any);
const TenantModelsModelIdIndexRoute =
  TenantModelsModelIdIndexRouteImport.update({
    id: '/models/$modelId/',
    path: '/models/$modelId/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdIndexRoute =
  TenantProjectsProjectIdIndexRouteImport.update({
    id: '/projects/$projectId/',
    path: '/projects/$projectId/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdActivityRoute =
  TenantProjectsProjectIdActivityRouteImport.update({
    id: '/projects/$projectId/activity',
    path: '/projects/$projectId/activity',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdAgentsRoute =
  TenantProjectsProjectIdAgentsRouteImport.update({
    id: '/projects/$projectId/agents',
    path: '/projects/$projectId/agents',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdCodeAssistantRoute =
  TenantProjectsProjectIdCodeAssistantRouteImport.update({
    id: '/projects/$projectId/code-assistant',
    path: '/projects/$projectId/code-assistant',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdCostsRoute =
  TenantProjectsProjectIdCostsRouteImport.update({
    id: '/projects/$projectId/costs',
    path: '/projects/$projectId/costs',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdLlmKeysRoute =
  TenantProjectsProjectIdLlmKeysRouteImport.update({
    id: '/projects/$projectId/llm-keys',
    path: '/projects/$projectId/llm-keys',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdMetricsRoute =
  TenantProjectsProjectIdMetricsRouteImport.update({
    id: '/projects/$projectId/metrics',
    path: '/projects/$projectId/metrics',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdSettingsRoute =
  TenantProjectsProjectIdSettingsRouteImport.update({
    id: '/projects/$projectId/settings',
    path: '/projects/$projectId/settings',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantResourcesDevicesIndexRoute =
  TenantResourcesDevicesIndexRouteImport.update({
    id: '/resources/devices/',
    path: '/resources/devices/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantResourcesDevicesDeviceIdRoute =
  TenantResourcesDevicesDeviceIdRouteImport.update({
    id: '/resources/devices/$deviceId',
    path: '/resources/devices/$deviceId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantResourcesDevicesEnrollRoute =
  TenantResourcesDevicesEnrollRouteImport.update({
    id: '/resources/devices/enroll',
    path: '/resources/devices/enroll',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantResourcesInfrastructuresIndexRoute =
  TenantResourcesInfrastructuresIndexRouteImport.update({
    id: '/resources/infrastructures/',
    path: '/resources/infrastructures/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantResourcesInfrastructuresInfrastructureIdRoute =
  TenantResourcesInfrastructuresInfrastructureIdRouteImport.update({
    id: '/resources/infrastructures/$infrastructureId',
    path: '/resources/infrastructures/$infrastructureId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantResourcesInfrastructuresNewRoute =
  TenantResourcesInfrastructuresNewRouteImport.update({
    id: '/resources/infrastructures/new',
    path: '/resources/infrastructures/new',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantResourcesInstanceTypesIndexRoute =
  TenantResourcesInstanceTypesIndexRouteImport.update({
    id: '/resources/instance-types/',
    path: '/resources/instance-types/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantResourcesInstanceTypesInstanceTypeIdRoute =
  TenantResourcesInstanceTypesInstanceTypeIdRouteImport.update({
    id: '/resources/instance-types/$instanceTypeId',
    path: '/resources/instance-types/$instanceTypeId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantResourcesQuotasIndexRoute =
  TenantResourcesQuotasIndexRouteImport.update({
    id: '/resources/quotas/',
    path: '/resources/quotas/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantResourcesQuotasQuotaKeyRoute =
  TenantResourcesQuotasQuotaKeyRouteImport.update({
    id: '/resources/quotas/$quotaKey',
    path: '/resources/quotas/$quotaKey',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantRuntimesRuntimeIdIndexRoute =
  TenantRuntimesRuntimeIdIndexRouteImport.update({
    id: '/runtimes/$runtimeId/',
    path: '/runtimes/$runtimeId/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantSqlWarehouseIdIndexRoute =
  TenantSqlWarehouseIdIndexRouteImport.update({
    id: '/sql/$warehouseId/',
    path: '/sql/$warehouseId/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantSqlWarehouseIdQueryRoute =
  TenantSqlWarehouseIdQueryRouteImport.update({
    id: '/sql/$warehouseId/query',
    path: '/sql/$warehouseId/query',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantTokensAgentsIdentityIdRoute =
  TenantTokensAgentsIdentityIdRouteImport.update({
    id: '/tokens/agents/$identityId',
    path: '/tokens/agents/$identityId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantTokensApiApplicationIdRoute =
  TenantTokensApiApplicationIdRouteImport.update({
    id: '/tokens/api/$applicationId',
    path: '/tokens/api/$applicationId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantCatalogLayerDatabaseIndexRoute =
  TenantCatalogLayerDatabaseIndexRouteImport.update({
    id: '/catalog/$layer/$database/',
    path: '/catalog/$layer/$database/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantCatalogLayerDatabaseNewRoute =
  TenantCatalogLayerDatabaseNewRouteImport.update({
    id: '/catalog/$layer/$database/new',
    path: '/catalog/$layer/$database/new',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantJobsJobIdRunsRunIdRoute =
  TenantJobsJobIdRunsRunIdRouteImport.update({
    id: '/jobs/$jobId/runs/$runId',
    path: '/jobs/$jobId/runs/$runId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantModelsModelIdVersionsVersionIdRoute =
  TenantModelsModelIdVersionsVersionIdRouteImport.update({
    id: '/models/$modelId/versions/$versionId',
    path: '/models/$modelId/versions/$versionId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantModelsModelIdVersionsNewRoute =
  TenantModelsModelIdVersionsNewRouteImport.update({
    id: '/models/$modelId/versions/new',
    path: '/models/$modelId/versions/new',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdApprovalsApprovalIdRoute =
  TenantProjectsProjectIdApprovalsApprovalIdRouteImport.update({
    id: '/projects/$projectId/approvals/$approvalId',
    path: '/projects/$projectId/approvals/$approvalId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdAssistantIndexRoute =
  TenantProjectsProjectIdAssistantIndexRouteImport.update({
    id: '/projects/$projectId/assistant/',
    path: '/projects/$projectId/assistant/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdAssistantIndexIdRoute =
  TenantProjectsProjectIdAssistantIndexIdRouteImport.update({
    id: '/projects/$projectId/assistant/$indexId',
    path: '/projects/$projectId/assistant/$indexId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdAssistantNewRoute =
  TenantProjectsProjectIdAssistantNewRouteImport.update({
    id: '/projects/$projectId/assistant/new',
    path: '/projects/$projectId/assistant/new',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdConnectionsIndexRoute =
  TenantProjectsProjectIdConnectionsIndexRouteImport.update({
    id: '/projects/$projectId/connections/',
    path: '/projects/$projectId/connections/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdConnectionsConnectionIdRoute =
  TenantProjectsProjectIdConnectionsConnectionIdRouteImport.update({
    id: '/projects/$projectId/connections/$connectionId',
    path: '/projects/$projectId/connections/$connectionId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdConnectionsNewRoute =
  TenantProjectsProjectIdConnectionsNewRouteImport.update({
    id: '/projects/$projectId/connections/new',
    path: '/projects/$projectId/connections/new',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdEndpointsIndexRoute =
  TenantProjectsProjectIdEndpointsIndexRouteImport.update({
    id: '/projects/$projectId/endpoints/',
    path: '/projects/$projectId/endpoints/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdEndpointsEndpointIdRoute =
  TenantProjectsProjectIdEndpointsEndpointIdRouteImport.update({
    id: '/projects/$projectId/endpoints/$endpointId',
    path: '/projects/$projectId/endpoints/$endpointId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdEndpointsNewRoute =
  TenantProjectsProjectIdEndpointsNewRouteImport.update({
    id: '/projects/$projectId/endpoints/new',
    path: '/projects/$projectId/endpoints/new',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdExperimentsIndexRoute =
  TenantProjectsProjectIdExperimentsIndexRouteImport.update({
    id: '/projects/$projectId/experiments/',
    path: '/projects/$projectId/experiments/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdExperimentsNewRoute =
  TenantProjectsProjectIdExperimentsNewRouteImport.update({
    id: '/projects/$projectId/experiments/new',
    path: '/projects/$projectId/experiments/new',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdJobsIndexRoute =
  TenantProjectsProjectIdJobsIndexRouteImport.update({
    id: '/projects/$projectId/jobs/',
    path: '/projects/$projectId/jobs/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdJobsNewRoute =
  TenantProjectsProjectIdJobsNewRouteImport.update({
    id: '/projects/$projectId/jobs/new',
    path: '/projects/$projectId/jobs/new',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdMembersIndexRoute =
  TenantProjectsProjectIdMembersIndexRouteImport.update({
    id: '/projects/$projectId/members/',
    path: '/projects/$projectId/members/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdMembersNewRoute =
  TenantProjectsProjectIdMembersNewRouteImport.update({
    id: '/projects/$projectId/members/new',
    path: '/projects/$projectId/members/new',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdTriggersIndexRoute =
  TenantProjectsProjectIdTriggersIndexRouteImport.update({
    id: '/projects/$projectId/triggers/',
    path: '/projects/$projectId/triggers/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdWorkflowsIndexRoute =
  TenantProjectsProjectIdWorkflowsIndexRouteImport.update({
    id: '/projects/$projectId/workflows/',
    path: '/projects/$projectId/workflows/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdWorkflowsEditorRoute =
  TenantProjectsProjectIdWorkflowsEditorRouteImport.update({
    id: '/projects/$projectId/workflows/editor',
    path: '/projects/$projectId/workflows/editor',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdWorkflowsImportOozieRoute =
  TenantProjectsProjectIdWorkflowsImportOozieRouteImport.update({
    id: '/projects/$projectId/workflows/import-oozie',
    path: '/projects/$projectId/workflows/import-oozie',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdWorkflowsNewRoute =
  TenantProjectsProjectIdWorkflowsNewRouteImport.update({
    id: '/projects/$projectId/workflows/new',
    path: '/projects/$projectId/workflows/new',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantRuntimesRuntimeIdBuildsBuildIdRoute =
  TenantRuntimesRuntimeIdBuildsBuildIdRouteImport.update({
    id: '/runtimes/$runtimeId/builds/$buildId',
    path: '/runtimes/$runtimeId/builds/$buildId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantRuntimesRuntimeIdBuildsNewRoute =
  TenantRuntimesRuntimeIdBuildsNewRouteImport.update({
    id: '/runtimes/$runtimeId/builds/new',
    path: '/runtimes/$runtimeId/builds/new',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantRuntimesRuntimeIdVersionsVersionIdRoute =
  TenantRuntimesRuntimeIdVersionsVersionIdRouteImport.update({
    id: '/runtimes/$runtimeId/versions/$versionId',
    path: '/runtimes/$runtimeId/versions/$versionId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantRuntimesRuntimeIdVersionsNewRoute =
  TenantRuntimesRuntimeIdVersionsNewRouteImport.update({
    id: '/runtimes/$runtimeId/versions/new',
    path: '/runtimes/$runtimeId/versions/new',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantCatalogLayerDatabaseTableIndexRoute =
  TenantCatalogLayerDatabaseTableIndexRouteImport.update({
    id: '/catalog/$layer/$database/$table/',
    path: '/catalog/$layer/$database/$table/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantCatalogLayerDatabaseTableFieldRoute =
  TenantCatalogLayerDatabaseTableFieldRouteImport.update({
    id: '/catalog/$layer/$database/$table/$field',
    path: '/catalog/$layer/$database/$table/$field',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantCatalogLayerDatabaseTableNewRoute =
  TenantCatalogLayerDatabaseTableNewRouteImport.update({
    id: '/catalog/$layer/$database/$table/new',
    path: '/catalog/$layer/$database/$table/new',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdExperimentsExperimentIdIndexRoute =
  TenantProjectsProjectIdExperimentsExperimentIdIndexRouteImport.update({
    id: '/projects/$projectId/experiments/$experimentId/',
    path: '/projects/$projectId/experiments/$experimentId/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdExperimentsExperimentIdCompareRoute =
  TenantProjectsProjectIdExperimentsExperimentIdCompareRouteImport.update({
    id: '/projects/$projectId/experiments/$experimentId/compare',
    path: '/projects/$projectId/experiments/$experimentId/compare',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdJobsJobIdIndexRoute =
  TenantProjectsProjectIdJobsJobIdIndexRouteImport.update({
    id: '/projects/$projectId/jobs/$jobId/',
    path: '/projects/$projectId/jobs/$jobId/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdWorkflowsWorkflowIdIndexRoute =
  TenantProjectsProjectIdWorkflowsWorkflowIdIndexRouteImport.update({
    id: '/projects/$projectId/workflows/$workflowId/',
    path: '/projects/$projectId/workflows/$workflowId/',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdWorkflowsWorkflowIdEditorRoute =
  TenantProjectsProjectIdWorkflowsWorkflowIdEditorRouteImport.update({
    id: '/projects/$projectId/workflows/$workflowId/editor',
    path: '/projects/$projectId/workflows/$workflowId/editor',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdExperimentsExperimentIdRunsRunIdRoute =
  TenantProjectsProjectIdExperimentsExperimentIdRunsRunIdRouteImport.update({
    id: '/projects/$projectId/experiments/$experimentId/runs/$runId',
    path: '/projects/$projectId/experiments/$experimentId/runs/$runId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdJobsJobIdRunsRunIdRoute =
  TenantProjectsProjectIdJobsJobIdRunsRunIdRouteImport.update({
    id: '/projects/$projectId/jobs/$jobId/runs/$runId',
    path: '/projects/$projectId/jobs/$jobId/runs/$runId',
    getParentRoute: () => TenantRoute,
  } as any);
const TenantProjectsProjectIdWorkflowsWorkflowIdRunsRunIdRoute =
  TenantProjectsProjectIdWorkflowsWorkflowIdRunsRunIdRouteImport.update({
    id: '/projects/$projectId/workflows/$workflowId/runs/$runId',
    path: '/projects/$projectId/workflows/$workflowId/runs/$runId',
    getParentRoute: () => TenantRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/$tenant': typeof TenantRouteWithChildren;
  '/callback': typeof CallbackRoute;
  '/login': typeof LoginRoute;
  '/silent-callback': typeof SilentCallbackRoute;
  '/$tenant/agents': typeof TenantAgentsRoute;
  '/$tenant/api-docs': typeof TenantApiDocsRoute;
  '/$tenant/assistant': typeof TenantAssistantRoute;
  '/$tenant/audit': typeof TenantAuditRoute;
  '/$tenant/audit-trail': typeof TenantAuditTrailRoute;
  '/$tenant/branding': typeof TenantBrandingRoute;
  '/$tenant/code-assistant': typeof TenantCodeAssistantRoute;
  '/$tenant/jupyter': typeof TenantJupyterRoute;
  '/$tenant/llm-keys': typeof TenantLlmKeysRoute;
  '/$tenant/me': typeof TenantMeRoute;
  '/$tenant/mfa': typeof TenantMfaRoute;
  '/$tenant/notifications': typeof TenantNotificationsRoute;
  '/$tenant/overview': typeof TenantOverviewRoute;
  '/$tenant/preferences': typeof TenantPreferencesRoute;
  '/$tenant/rstudio': typeof TenantRstudioRoute;
  '/$tenant/search': typeof TenantSearchRoute;
  '/$tenant/secret-store': typeof TenantSecretStoreRoute;
  '/$tenant/subscription': typeof TenantSubscriptionRoute;
  '/$tenant/usage': typeof TenantUsageRoute;
  '/$tenant/vscode': typeof TenantVscodeRoute;
  '/$tenant/': typeof TenantIndexRoute;
  '/$tenant/agent-policies/$policyId': typeof TenantAgentPoliciesPolicyIdRoute;
  '/$tenant/agent-policies/new': typeof TenantAgentPoliciesNewRoute;
  '/$tenant/billing/pricing': typeof TenantBillingPricingRoute;
  '/$tenant/bridges/$bridgeId': typeof TenantBridgesBridgeIdRoute;
  '/$tenant/bridges/new': typeof TenantBridgesNewRoute;
  '/$tenant/buckets/$bucketId': typeof TenantBucketsBucketIdRoute;
  '/$tenant/buckets/new': typeof TenantBucketsNewRoute;
  '/$tenant/catalog/new': typeof TenantCatalogNewRoute;
  '/$tenant/editor/$graphId': typeof TenantEditorGraphIdRoute;
  '/$tenant/editor/new': typeof TenantEditorNewRoute;
  '/$tenant/firewall/$ruleId': typeof TenantFirewallRuleIdRoute;
  '/$tenant/firewall/new': typeof TenantFirewallNewRoute;
  '/$tenant/glossary/$termId': typeof TenantGlossaryTermIdRoute;
  '/$tenant/glossary/new': typeof TenantGlossaryNewRoute;
  '/$tenant/groups/$groupId': typeof TenantGroupsGroupIdRoute;
  '/$tenant/groups/new': typeof TenantGroupsNewRoute;
  '/$tenant/identity-providers/$identityProviderId': typeof TenantIdentityProvidersIdentityProviderIdRoute;
  '/$tenant/identity-providers/new': typeof TenantIdentityProvidersNewRoute;
  '/$tenant/lineage/graph': typeof TenantLineageGraphRoute;
  '/$tenant/members/$userId': typeof TenantMembersUserIdRoute;
  '/$tenant/members/new': typeof TenantMembersNewRoute;
  '/$tenant/models/new': typeof TenantModelsNewRoute;
  '/$tenant/projects/new': typeof TenantProjectsNewRoute;
  '/$tenant/roles/$roleId': typeof TenantRolesRoleIdRoute;
  '/$tenant/roles/assignments': typeof TenantRolesAssignmentsRoute;
  '/$tenant/roles/new': typeof TenantRolesNewRoute;
  '/$tenant/runtimes/new': typeof TenantRuntimesNewRoute;
  '/$tenant/secrets/$secretId': typeof TenantSecretsSecretIdRoute;
  '/$tenant/secrets/new': typeof TenantSecretsNewRoute;
  '/$tenant/sessions/$sessionId': typeof TenantSessionsSessionIdRoute;
  '/$tenant/sessions/new': typeof TenantSessionsNewRoute;
  '/$tenant/sql/new': typeof TenantSqlNewRoute;
  '/$tenant/streams/$streamId': typeof TenantStreamsStreamIdRoute;
  '/$tenant/streams/new': typeof TenantStreamsNewRoute;
  '/$tenant/support/$ticketId': typeof TenantSupportTicketIdRoute;
  '/$tenant/support/new': typeof TenantSupportNewRoute;
  '/$tenant/tokens/new': typeof TenantTokensNewRoute;
  '/$tenant/workflows/editor': typeof TenantWorkflowsEditorRoute;
  '/$tenant/workspaces/$workspaceId': typeof TenantWorkspacesWorkspaceIdRoute;
  '/$tenant/workspaces/new': typeof TenantWorkspacesNewRoute;
  '/$tenant/agent-policies/': typeof TenantAgentPoliciesIndexRoute;
  '/$tenant/billing/': typeof TenantBillingIndexRoute;
  '/$tenant/bridges/': typeof TenantBridgesIndexRoute;
  '/$tenant/buckets/': typeof TenantBucketsIndexRoute;
  '/$tenant/catalog/': typeof TenantCatalogIndexRoute;
  '/$tenant/connections/': typeof TenantConnectionsIndexRoute;
  '/$tenant/editor/': typeof TenantEditorIndexRoute;
  '/$tenant/endpoints/': typeof TenantEndpointsIndexRoute;
  '/$tenant/experiments/': typeof TenantExperimentsIndexRoute;
  '/$tenant/firewall/': typeof TenantFirewallIndexRoute;
  '/$tenant/glossary/': typeof TenantGlossaryIndexRoute;
  '/$tenant/groups/': typeof TenantGroupsIndexRoute;
  '/$tenant/identity-providers/': typeof TenantIdentityProvidersIndexRoute;
  '/$tenant/jobs/': typeof TenantJobsIndexRoute;
  '/$tenant/libraries/': typeof TenantLibrariesIndexRoute;
  '/$tenant/lineage/': typeof TenantLineageIndexRoute;
  '/$tenant/llm/': typeof TenantLlmIndexRoute;
  '/$tenant/members/': typeof TenantMembersIndexRoute;
  '/$tenant/models/': typeof TenantModelsIndexRoute;
  '/$tenant/projects/': typeof TenantProjectsIndexRoute;
  '/$tenant/roles/': typeof TenantRolesIndexRoute;
  '/$tenant/runtimes/': typeof TenantRuntimesIndexRoute;
  '/$tenant/secrets/': typeof TenantSecretsIndexRoute;
  '/$tenant/sessions/': typeof TenantSessionsIndexRoute;
  '/$tenant/sql/': typeof TenantSqlIndexRoute;
  '/$tenant/streams/': typeof TenantStreamsIndexRoute;
  '/$tenant/support/': typeof TenantSupportIndexRoute;
  '/$tenant/tokens/': typeof TenantTokensIndexRoute;
  '/$tenant/triggers/': typeof TenantTriggersIndexRoute;
  '/$tenant/workflows/': typeof TenantWorkflowsIndexRoute;
  '/$tenant/workspaces/': typeof TenantWorkspacesIndexRoute;
  '/$tenant/billing/invoices/$invoiceId': typeof TenantBillingInvoicesInvoiceIdRoute;
  '/$tenant/billing/payment-methods/new': typeof TenantBillingPaymentMethodsNewRoute;
  '/$tenant/billing/transactions/$transactionId': typeof TenantBillingTransactionsTransactionIdRoute;
  '/$tenant/catalog/$layer/new': typeof TenantCatalogLayerNewRoute;
  '/$tenant/editor/templates/$templateName': typeof TenantEditorTemplatesTemplateNameRoute;
  '/$tenant/llm/budgets/$projectId': typeof TenantLlmBudgetsProjectIdRoute;
  '/$tenant/llm/models/$modelId': typeof TenantLlmModelsModelIdRoute;
  '/$tenant/llm/models/new': typeof TenantLlmModelsNewRoute;
  '/$tenant/llm/providers/$providerId': typeof TenantLlmProvidersProviderIdRoute;
  '/$tenant/llm/providers/new': typeof TenantLlmProvidersNewRoute;
  '/$tenant/projects/$projectId/activity': typeof TenantProjectsProjectIdActivityRoute;
  '/$tenant/projects/$projectId/agents': typeof TenantProjectsProjectIdAgentsRoute;
  '/$tenant/projects/$projectId/code-assistant': typeof TenantProjectsProjectIdCodeAssistantRoute;
  '/$tenant/projects/$projectId/costs': typeof TenantProjectsProjectIdCostsRoute;
  '/$tenant/projects/$projectId/llm-keys': typeof TenantProjectsProjectIdLlmKeysRoute;
  '/$tenant/projects/$projectId/metrics': typeof TenantProjectsProjectIdMetricsRoute;
  '/$tenant/projects/$projectId/settings': typeof TenantProjectsProjectIdSettingsRoute;
  '/$tenant/resources/devices/$deviceId': typeof TenantResourcesDevicesDeviceIdRoute;
  '/$tenant/resources/devices/enroll': typeof TenantResourcesDevicesEnrollRoute;
  '/$tenant/resources/infrastructures/$infrastructureId': typeof TenantResourcesInfrastructuresInfrastructureIdRoute;
  '/$tenant/resources/infrastructures/new': typeof TenantResourcesInfrastructuresNewRoute;
  '/$tenant/resources/instance-types/$instanceTypeId': typeof TenantResourcesInstanceTypesInstanceTypeIdRoute;
  '/$tenant/resources/quotas/$quotaKey': typeof TenantResourcesQuotasQuotaKeyRoute;
  '/$tenant/sql/$warehouseId/query': typeof TenantSqlWarehouseIdQueryRoute;
  '/$tenant/tokens/agents/$identityId': typeof TenantTokensAgentsIdentityIdRoute;
  '/$tenant/tokens/api/$applicationId': typeof TenantTokensApiApplicationIdRoute;
  '/$tenant/billing/invoices/': typeof TenantBillingInvoicesIndexRoute;
  '/$tenant/billing/payment-methods/': typeof TenantBillingPaymentMethodsIndexRoute;
  '/$tenant/billing/transactions/': typeof TenantBillingTransactionsIndexRoute;
  '/$tenant/catalog/$layer/': typeof TenantCatalogLayerIndexRoute;
  '/$tenant/editor/templates/': typeof TenantEditorTemplatesIndexRoute;
  '/$tenant/models/$modelId/': typeof TenantModelsModelIdIndexRoute;
  '/$tenant/projects/$projectId/': typeof TenantProjectsProjectIdIndexRoute;
  '/$tenant/resources/devices/': typeof TenantResourcesDevicesIndexRoute;
  '/$tenant/resources/infrastructures/': typeof TenantResourcesInfrastructuresIndexRoute;
  '/$tenant/resources/instance-types/': typeof TenantResourcesInstanceTypesIndexRoute;
  '/$tenant/resources/quotas/': typeof TenantResourcesQuotasIndexRoute;
  '/$tenant/runtimes/$runtimeId/': typeof TenantRuntimesRuntimeIdIndexRoute;
  '/$tenant/sql/$warehouseId/': typeof TenantSqlWarehouseIdIndexRoute;
  '/$tenant/catalog/$layer/$database/new': typeof TenantCatalogLayerDatabaseNewRoute;
  '/$tenant/jobs/$jobId/runs/$runId': typeof TenantJobsJobIdRunsRunIdRoute;
  '/$tenant/models/$modelId/versions/$versionId': typeof TenantModelsModelIdVersionsVersionIdRoute;
  '/$tenant/models/$modelId/versions/new': typeof TenantModelsModelIdVersionsNewRoute;
  '/$tenant/projects/$projectId/approvals/$approvalId': typeof TenantProjectsProjectIdApprovalsApprovalIdRoute;
  '/$tenant/projects/$projectId/assistant/$indexId': typeof TenantProjectsProjectIdAssistantIndexIdRoute;
  '/$tenant/projects/$projectId/assistant/new': typeof TenantProjectsProjectIdAssistantNewRoute;
  '/$tenant/projects/$projectId/connections/$connectionId': typeof TenantProjectsProjectIdConnectionsConnectionIdRoute;
  '/$tenant/projects/$projectId/connections/new': typeof TenantProjectsProjectIdConnectionsNewRoute;
  '/$tenant/projects/$projectId/endpoints/$endpointId': typeof TenantProjectsProjectIdEndpointsEndpointIdRoute;
  '/$tenant/projects/$projectId/endpoints/new': typeof TenantProjectsProjectIdEndpointsNewRoute;
  '/$tenant/projects/$projectId/experiments/new': typeof TenantProjectsProjectIdExperimentsNewRoute;
  '/$tenant/projects/$projectId/jobs/new': typeof TenantProjectsProjectIdJobsNewRoute;
  '/$tenant/projects/$projectId/members/new': typeof TenantProjectsProjectIdMembersNewRoute;
  '/$tenant/projects/$projectId/workflows/editor': typeof TenantProjectsProjectIdWorkflowsEditorRoute;
  '/$tenant/projects/$projectId/workflows/import-oozie': typeof TenantProjectsProjectIdWorkflowsImportOozieRoute;
  '/$tenant/projects/$projectId/workflows/new': typeof TenantProjectsProjectIdWorkflowsNewRoute;
  '/$tenant/runtimes/$runtimeId/builds/$buildId': typeof TenantRuntimesRuntimeIdBuildsBuildIdRoute;
  '/$tenant/runtimes/$runtimeId/builds/new': typeof TenantRuntimesRuntimeIdBuildsNewRoute;
  '/$tenant/runtimes/$runtimeId/versions/$versionId': typeof TenantRuntimesRuntimeIdVersionsVersionIdRoute;
  '/$tenant/runtimes/$runtimeId/versions/new': typeof TenantRuntimesRuntimeIdVersionsNewRoute;
  '/$tenant/catalog/$layer/$database/': typeof TenantCatalogLayerDatabaseIndexRoute;
  '/$tenant/projects/$projectId/assistant/': typeof TenantProjectsProjectIdAssistantIndexRoute;
  '/$tenant/projects/$projectId/connections/': typeof TenantProjectsProjectIdConnectionsIndexRoute;
  '/$tenant/projects/$projectId/endpoints/': typeof TenantProjectsProjectIdEndpointsIndexRoute;
  '/$tenant/projects/$projectId/experiments/': typeof TenantProjectsProjectIdExperimentsIndexRoute;
  '/$tenant/projects/$projectId/jobs/': typeof TenantProjectsProjectIdJobsIndexRoute;
  '/$tenant/projects/$projectId/members/': typeof TenantProjectsProjectIdMembersIndexRoute;
  '/$tenant/projects/$projectId/triggers/': typeof TenantProjectsProjectIdTriggersIndexRoute;
  '/$tenant/projects/$projectId/workflows/': typeof TenantProjectsProjectIdWorkflowsIndexRoute;
  '/$tenant/catalog/$layer/$database/$table/$field': typeof TenantCatalogLayerDatabaseTableFieldRoute;
  '/$tenant/catalog/$layer/$database/$table/new': typeof TenantCatalogLayerDatabaseTableNewRoute;
  '/$tenant/projects/$projectId/experiments/$experimentId/compare': typeof TenantProjectsProjectIdExperimentsExperimentIdCompareRoute;
  '/$tenant/projects/$projectId/workflows/$workflowId/editor': typeof TenantProjectsProjectIdWorkflowsWorkflowIdEditorRoute;
  '/$tenant/catalog/$layer/$database/$table/': typeof TenantCatalogLayerDatabaseTableIndexRoute;
  '/$tenant/projects/$projectId/experiments/$experimentId/': typeof TenantProjectsProjectIdExperimentsExperimentIdIndexRoute;
  '/$tenant/projects/$projectId/jobs/$jobId/': typeof TenantProjectsProjectIdJobsJobIdIndexRoute;
  '/$tenant/projects/$projectId/workflows/$workflowId/': typeof TenantProjectsProjectIdWorkflowsWorkflowIdIndexRoute;
  '/$tenant/projects/$projectId/experiments/$experimentId/runs/$runId': typeof TenantProjectsProjectIdExperimentsExperimentIdRunsRunIdRoute;
  '/$tenant/projects/$projectId/jobs/$jobId/runs/$runId': typeof TenantProjectsProjectIdJobsJobIdRunsRunIdRoute;
  '/$tenant/projects/$projectId/workflows/$workflowId/runs/$runId': typeof TenantProjectsProjectIdWorkflowsWorkflowIdRunsRunIdRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/callback': typeof CallbackRoute;
  '/login': typeof LoginRoute;
  '/silent-callback': typeof SilentCallbackRoute;
  '/$tenant/agents': typeof TenantAgentsRoute;
  '/$tenant/api-docs': typeof TenantApiDocsRoute;
  '/$tenant/assistant': typeof TenantAssistantRoute;
  '/$tenant/audit': typeof TenantAuditRoute;
  '/$tenant/audit-trail': typeof TenantAuditTrailRoute;
  '/$tenant/branding': typeof TenantBrandingRoute;
  '/$tenant/code-assistant': typeof TenantCodeAssistantRoute;
  '/$tenant/jupyter': typeof TenantJupyterRoute;
  '/$tenant/llm-keys': typeof TenantLlmKeysRoute;
  '/$tenant/me': typeof TenantMeRoute;
  '/$tenant/mfa': typeof TenantMfaRoute;
  '/$tenant/notifications': typeof TenantNotificationsRoute;
  '/$tenant/overview': typeof TenantOverviewRoute;
  '/$tenant/preferences': typeof TenantPreferencesRoute;
  '/$tenant/rstudio': typeof TenantRstudioRoute;
  '/$tenant/search': typeof TenantSearchRoute;
  '/$tenant/secret-store': typeof TenantSecretStoreRoute;
  '/$tenant/subscription': typeof TenantSubscriptionRoute;
  '/$tenant/usage': typeof TenantUsageRoute;
  '/$tenant/vscode': typeof TenantVscodeRoute;
  '/$tenant': typeof TenantIndexRoute;
  '/$tenant/agent-policies/$policyId': typeof TenantAgentPoliciesPolicyIdRoute;
  '/$tenant/agent-policies/new': typeof TenantAgentPoliciesNewRoute;
  '/$tenant/billing/pricing': typeof TenantBillingPricingRoute;
  '/$tenant/bridges/$bridgeId': typeof TenantBridgesBridgeIdRoute;
  '/$tenant/bridges/new': typeof TenantBridgesNewRoute;
  '/$tenant/buckets/$bucketId': typeof TenantBucketsBucketIdRoute;
  '/$tenant/buckets/new': typeof TenantBucketsNewRoute;
  '/$tenant/catalog/new': typeof TenantCatalogNewRoute;
  '/$tenant/editor/$graphId': typeof TenantEditorGraphIdRoute;
  '/$tenant/editor/new': typeof TenantEditorNewRoute;
  '/$tenant/firewall/$ruleId': typeof TenantFirewallRuleIdRoute;
  '/$tenant/firewall/new': typeof TenantFirewallNewRoute;
  '/$tenant/glossary/$termId': typeof TenantGlossaryTermIdRoute;
  '/$tenant/glossary/new': typeof TenantGlossaryNewRoute;
  '/$tenant/groups/$groupId': typeof TenantGroupsGroupIdRoute;
  '/$tenant/groups/new': typeof TenantGroupsNewRoute;
  '/$tenant/identity-providers/$identityProviderId': typeof TenantIdentityProvidersIdentityProviderIdRoute;
  '/$tenant/identity-providers/new': typeof TenantIdentityProvidersNewRoute;
  '/$tenant/lineage/graph': typeof TenantLineageGraphRoute;
  '/$tenant/members/$userId': typeof TenantMembersUserIdRoute;
  '/$tenant/members/new': typeof TenantMembersNewRoute;
  '/$tenant/models/new': typeof TenantModelsNewRoute;
  '/$tenant/projects/new': typeof TenantProjectsNewRoute;
  '/$tenant/roles/$roleId': typeof TenantRolesRoleIdRoute;
  '/$tenant/roles/assignments': typeof TenantRolesAssignmentsRoute;
  '/$tenant/roles/new': typeof TenantRolesNewRoute;
  '/$tenant/runtimes/new': typeof TenantRuntimesNewRoute;
  '/$tenant/secrets/$secretId': typeof TenantSecretsSecretIdRoute;
  '/$tenant/secrets/new': typeof TenantSecretsNewRoute;
  '/$tenant/sessions/$sessionId': typeof TenantSessionsSessionIdRoute;
  '/$tenant/sessions/new': typeof TenantSessionsNewRoute;
  '/$tenant/sql/new': typeof TenantSqlNewRoute;
  '/$tenant/streams/$streamId': typeof TenantStreamsStreamIdRoute;
  '/$tenant/streams/new': typeof TenantStreamsNewRoute;
  '/$tenant/support/$ticketId': typeof TenantSupportTicketIdRoute;
  '/$tenant/support/new': typeof TenantSupportNewRoute;
  '/$tenant/tokens/new': typeof TenantTokensNewRoute;
  '/$tenant/workflows/editor': typeof TenantWorkflowsEditorRoute;
  '/$tenant/workspaces/$workspaceId': typeof TenantWorkspacesWorkspaceIdRoute;
  '/$tenant/workspaces/new': typeof TenantWorkspacesNewRoute;
  '/$tenant/agent-policies': typeof TenantAgentPoliciesIndexRoute;
  '/$tenant/billing': typeof TenantBillingIndexRoute;
  '/$tenant/bridges': typeof TenantBridgesIndexRoute;
  '/$tenant/buckets': typeof TenantBucketsIndexRoute;
  '/$tenant/catalog': typeof TenantCatalogIndexRoute;
  '/$tenant/connections': typeof TenantConnectionsIndexRoute;
  '/$tenant/editor': typeof TenantEditorIndexRoute;
  '/$tenant/endpoints': typeof TenantEndpointsIndexRoute;
  '/$tenant/experiments': typeof TenantExperimentsIndexRoute;
  '/$tenant/firewall': typeof TenantFirewallIndexRoute;
  '/$tenant/glossary': typeof TenantGlossaryIndexRoute;
  '/$tenant/groups': typeof TenantGroupsIndexRoute;
  '/$tenant/identity-providers': typeof TenantIdentityProvidersIndexRoute;
  '/$tenant/jobs': typeof TenantJobsIndexRoute;
  '/$tenant/libraries': typeof TenantLibrariesIndexRoute;
  '/$tenant/lineage': typeof TenantLineageIndexRoute;
  '/$tenant/llm': typeof TenantLlmIndexRoute;
  '/$tenant/members': typeof TenantMembersIndexRoute;
  '/$tenant/models': typeof TenantModelsIndexRoute;
  '/$tenant/projects': typeof TenantProjectsIndexRoute;
  '/$tenant/roles': typeof TenantRolesIndexRoute;
  '/$tenant/runtimes': typeof TenantRuntimesIndexRoute;
  '/$tenant/secrets': typeof TenantSecretsIndexRoute;
  '/$tenant/sessions': typeof TenantSessionsIndexRoute;
  '/$tenant/sql': typeof TenantSqlIndexRoute;
  '/$tenant/streams': typeof TenantStreamsIndexRoute;
  '/$tenant/support': typeof TenantSupportIndexRoute;
  '/$tenant/tokens': typeof TenantTokensIndexRoute;
  '/$tenant/triggers': typeof TenantTriggersIndexRoute;
  '/$tenant/workflows': typeof TenantWorkflowsIndexRoute;
  '/$tenant/workspaces': typeof TenantWorkspacesIndexRoute;
  '/$tenant/billing/invoices/$invoiceId': typeof TenantBillingInvoicesInvoiceIdRoute;
  '/$tenant/billing/payment-methods/new': typeof TenantBillingPaymentMethodsNewRoute;
  '/$tenant/billing/transactions/$transactionId': typeof TenantBillingTransactionsTransactionIdRoute;
  '/$tenant/catalog/$layer/new': typeof TenantCatalogLayerNewRoute;
  '/$tenant/editor/templates/$templateName': typeof TenantEditorTemplatesTemplateNameRoute;
  '/$tenant/llm/budgets/$projectId': typeof TenantLlmBudgetsProjectIdRoute;
  '/$tenant/llm/models/$modelId': typeof TenantLlmModelsModelIdRoute;
  '/$tenant/llm/models/new': typeof TenantLlmModelsNewRoute;
  '/$tenant/llm/providers/$providerId': typeof TenantLlmProvidersProviderIdRoute;
  '/$tenant/llm/providers/new': typeof TenantLlmProvidersNewRoute;
  '/$tenant/projects/$projectId/activity': typeof TenantProjectsProjectIdActivityRoute;
  '/$tenant/projects/$projectId/agents': typeof TenantProjectsProjectIdAgentsRoute;
  '/$tenant/projects/$projectId/code-assistant': typeof TenantProjectsProjectIdCodeAssistantRoute;
  '/$tenant/projects/$projectId/costs': typeof TenantProjectsProjectIdCostsRoute;
  '/$tenant/projects/$projectId/llm-keys': typeof TenantProjectsProjectIdLlmKeysRoute;
  '/$tenant/projects/$projectId/metrics': typeof TenantProjectsProjectIdMetricsRoute;
  '/$tenant/projects/$projectId/settings': typeof TenantProjectsProjectIdSettingsRoute;
  '/$tenant/resources/devices/$deviceId': typeof TenantResourcesDevicesDeviceIdRoute;
  '/$tenant/resources/devices/enroll': typeof TenantResourcesDevicesEnrollRoute;
  '/$tenant/resources/infrastructures/$infrastructureId': typeof TenantResourcesInfrastructuresInfrastructureIdRoute;
  '/$tenant/resources/infrastructures/new': typeof TenantResourcesInfrastructuresNewRoute;
  '/$tenant/resources/instance-types/$instanceTypeId': typeof TenantResourcesInstanceTypesInstanceTypeIdRoute;
  '/$tenant/resources/quotas/$quotaKey': typeof TenantResourcesQuotasQuotaKeyRoute;
  '/$tenant/sql/$warehouseId/query': typeof TenantSqlWarehouseIdQueryRoute;
  '/$tenant/tokens/agents/$identityId': typeof TenantTokensAgentsIdentityIdRoute;
  '/$tenant/tokens/api/$applicationId': typeof TenantTokensApiApplicationIdRoute;
  '/$tenant/billing/invoices': typeof TenantBillingInvoicesIndexRoute;
  '/$tenant/billing/payment-methods': typeof TenantBillingPaymentMethodsIndexRoute;
  '/$tenant/billing/transactions': typeof TenantBillingTransactionsIndexRoute;
  '/$tenant/catalog/$layer': typeof TenantCatalogLayerIndexRoute;
  '/$tenant/editor/templates': typeof TenantEditorTemplatesIndexRoute;
  '/$tenant/models/$modelId': typeof TenantModelsModelIdIndexRoute;
  '/$tenant/projects/$projectId': typeof TenantProjectsProjectIdIndexRoute;
  '/$tenant/resources/devices': typeof TenantResourcesDevicesIndexRoute;
  '/$tenant/resources/infrastructures': typeof TenantResourcesInfrastructuresIndexRoute;
  '/$tenant/resources/instance-types': typeof TenantResourcesInstanceTypesIndexRoute;
  '/$tenant/resources/quotas': typeof TenantResourcesQuotasIndexRoute;
  '/$tenant/runtimes/$runtimeId': typeof TenantRuntimesRuntimeIdIndexRoute;
  '/$tenant/sql/$warehouseId': typeof TenantSqlWarehouseIdIndexRoute;
  '/$tenant/catalog/$layer/$database/new': typeof TenantCatalogLayerDatabaseNewRoute;
  '/$tenant/jobs/$jobId/runs/$runId': typeof TenantJobsJobIdRunsRunIdRoute;
  '/$tenant/models/$modelId/versions/$versionId': typeof TenantModelsModelIdVersionsVersionIdRoute;
  '/$tenant/models/$modelId/versions/new': typeof TenantModelsModelIdVersionsNewRoute;
  '/$tenant/projects/$projectId/approvals/$approvalId': typeof TenantProjectsProjectIdApprovalsApprovalIdRoute;
  '/$tenant/projects/$projectId/assistant/$indexId': typeof TenantProjectsProjectIdAssistantIndexIdRoute;
  '/$tenant/projects/$projectId/assistant/new': typeof TenantProjectsProjectIdAssistantNewRoute;
  '/$tenant/projects/$projectId/connections/$connectionId': typeof TenantProjectsProjectIdConnectionsConnectionIdRoute;
  '/$tenant/projects/$projectId/connections/new': typeof TenantProjectsProjectIdConnectionsNewRoute;
  '/$tenant/projects/$projectId/endpoints/$endpointId': typeof TenantProjectsProjectIdEndpointsEndpointIdRoute;
  '/$tenant/projects/$projectId/endpoints/new': typeof TenantProjectsProjectIdEndpointsNewRoute;
  '/$tenant/projects/$projectId/experiments/new': typeof TenantProjectsProjectIdExperimentsNewRoute;
  '/$tenant/projects/$projectId/jobs/new': typeof TenantProjectsProjectIdJobsNewRoute;
  '/$tenant/projects/$projectId/members/new': typeof TenantProjectsProjectIdMembersNewRoute;
  '/$tenant/projects/$projectId/workflows/editor': typeof TenantProjectsProjectIdWorkflowsEditorRoute;
  '/$tenant/projects/$projectId/workflows/import-oozie': typeof TenantProjectsProjectIdWorkflowsImportOozieRoute;
  '/$tenant/projects/$projectId/workflows/new': typeof TenantProjectsProjectIdWorkflowsNewRoute;
  '/$tenant/runtimes/$runtimeId/builds/$buildId': typeof TenantRuntimesRuntimeIdBuildsBuildIdRoute;
  '/$tenant/runtimes/$runtimeId/builds/new': typeof TenantRuntimesRuntimeIdBuildsNewRoute;
  '/$tenant/runtimes/$runtimeId/versions/$versionId': typeof TenantRuntimesRuntimeIdVersionsVersionIdRoute;
  '/$tenant/runtimes/$runtimeId/versions/new': typeof TenantRuntimesRuntimeIdVersionsNewRoute;
  '/$tenant/catalog/$layer/$database': typeof TenantCatalogLayerDatabaseIndexRoute;
  '/$tenant/projects/$projectId/assistant': typeof TenantProjectsProjectIdAssistantIndexRoute;
  '/$tenant/projects/$projectId/connections': typeof TenantProjectsProjectIdConnectionsIndexRoute;
  '/$tenant/projects/$projectId/endpoints': typeof TenantProjectsProjectIdEndpointsIndexRoute;
  '/$tenant/projects/$projectId/experiments': typeof TenantProjectsProjectIdExperimentsIndexRoute;
  '/$tenant/projects/$projectId/jobs': typeof TenantProjectsProjectIdJobsIndexRoute;
  '/$tenant/projects/$projectId/members': typeof TenantProjectsProjectIdMembersIndexRoute;
  '/$tenant/projects/$projectId/triggers': typeof TenantProjectsProjectIdTriggersIndexRoute;
  '/$tenant/projects/$projectId/workflows': typeof TenantProjectsProjectIdWorkflowsIndexRoute;
  '/$tenant/catalog/$layer/$database/$table/$field': typeof TenantCatalogLayerDatabaseTableFieldRoute;
  '/$tenant/catalog/$layer/$database/$table/new': typeof TenantCatalogLayerDatabaseTableNewRoute;
  '/$tenant/projects/$projectId/experiments/$experimentId/compare': typeof TenantProjectsProjectIdExperimentsExperimentIdCompareRoute;
  '/$tenant/projects/$projectId/workflows/$workflowId/editor': typeof TenantProjectsProjectIdWorkflowsWorkflowIdEditorRoute;
  '/$tenant/catalog/$layer/$database/$table': typeof TenantCatalogLayerDatabaseTableIndexRoute;
  '/$tenant/projects/$projectId/experiments/$experimentId': typeof TenantProjectsProjectIdExperimentsExperimentIdIndexRoute;
  '/$tenant/projects/$projectId/jobs/$jobId': typeof TenantProjectsProjectIdJobsJobIdIndexRoute;
  '/$tenant/projects/$projectId/workflows/$workflowId': typeof TenantProjectsProjectIdWorkflowsWorkflowIdIndexRoute;
  '/$tenant/projects/$projectId/experiments/$experimentId/runs/$runId': typeof TenantProjectsProjectIdExperimentsExperimentIdRunsRunIdRoute;
  '/$tenant/projects/$projectId/jobs/$jobId/runs/$runId': typeof TenantProjectsProjectIdJobsJobIdRunsRunIdRoute;
  '/$tenant/projects/$projectId/workflows/$workflowId/runs/$runId': typeof TenantProjectsProjectIdWorkflowsWorkflowIdRunsRunIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/$tenant': typeof TenantRouteWithChildren;
  '/callback': typeof CallbackRoute;
  '/login': typeof LoginRoute;
  '/silent-callback': typeof SilentCallbackRoute;
  '/$tenant/agents': typeof TenantAgentsRoute;
  '/$tenant/api-docs': typeof TenantApiDocsRoute;
  '/$tenant/assistant': typeof TenantAssistantRoute;
  '/$tenant/audit': typeof TenantAuditRoute;
  '/$tenant/audit-trail': typeof TenantAuditTrailRoute;
  '/$tenant/branding': typeof TenantBrandingRoute;
  '/$tenant/code-assistant': typeof TenantCodeAssistantRoute;
  '/$tenant/jupyter': typeof TenantJupyterRoute;
  '/$tenant/llm-keys': typeof TenantLlmKeysRoute;
  '/$tenant/me': typeof TenantMeRoute;
  '/$tenant/mfa': typeof TenantMfaRoute;
  '/$tenant/notifications': typeof TenantNotificationsRoute;
  '/$tenant/overview': typeof TenantOverviewRoute;
  '/$tenant/preferences': typeof TenantPreferencesRoute;
  '/$tenant/rstudio': typeof TenantRstudioRoute;
  '/$tenant/search': typeof TenantSearchRoute;
  '/$tenant/secret-store': typeof TenantSecretStoreRoute;
  '/$tenant/subscription': typeof TenantSubscriptionRoute;
  '/$tenant/usage': typeof TenantUsageRoute;
  '/$tenant/vscode': typeof TenantVscodeRoute;
  '/$tenant/': typeof TenantIndexRoute;
  '/$tenant/agent-policies/$policyId': typeof TenantAgentPoliciesPolicyIdRoute;
  '/$tenant/agent-policies/new': typeof TenantAgentPoliciesNewRoute;
  '/$tenant/billing/pricing': typeof TenantBillingPricingRoute;
  '/$tenant/bridges/$bridgeId': typeof TenantBridgesBridgeIdRoute;
  '/$tenant/bridges/new': typeof TenantBridgesNewRoute;
  '/$tenant/buckets/$bucketId': typeof TenantBucketsBucketIdRoute;
  '/$tenant/buckets/new': typeof TenantBucketsNewRoute;
  '/$tenant/catalog/new': typeof TenantCatalogNewRoute;
  '/$tenant/editor/$graphId': typeof TenantEditorGraphIdRoute;
  '/$tenant/editor/new': typeof TenantEditorNewRoute;
  '/$tenant/firewall/$ruleId': typeof TenantFirewallRuleIdRoute;
  '/$tenant/firewall/new': typeof TenantFirewallNewRoute;
  '/$tenant/glossary/$termId': typeof TenantGlossaryTermIdRoute;
  '/$tenant/glossary/new': typeof TenantGlossaryNewRoute;
  '/$tenant/groups/$groupId': typeof TenantGroupsGroupIdRoute;
  '/$tenant/groups/new': typeof TenantGroupsNewRoute;
  '/$tenant/identity-providers/$identityProviderId': typeof TenantIdentityProvidersIdentityProviderIdRoute;
  '/$tenant/identity-providers/new': typeof TenantIdentityProvidersNewRoute;
  '/$tenant/lineage/graph': typeof TenantLineageGraphRoute;
  '/$tenant/members/$userId': typeof TenantMembersUserIdRoute;
  '/$tenant/members/new': typeof TenantMembersNewRoute;
  '/$tenant/models/new': typeof TenantModelsNewRoute;
  '/$tenant/projects/new': typeof TenantProjectsNewRoute;
  '/$tenant/roles/$roleId': typeof TenantRolesRoleIdRoute;
  '/$tenant/roles/assignments': typeof TenantRolesAssignmentsRoute;
  '/$tenant/roles/new': typeof TenantRolesNewRoute;
  '/$tenant/runtimes/new': typeof TenantRuntimesNewRoute;
  '/$tenant/secrets/$secretId': typeof TenantSecretsSecretIdRoute;
  '/$tenant/secrets/new': typeof TenantSecretsNewRoute;
  '/$tenant/sessions/$sessionId': typeof TenantSessionsSessionIdRoute;
  '/$tenant/sessions/new': typeof TenantSessionsNewRoute;
  '/$tenant/sql/new': typeof TenantSqlNewRoute;
  '/$tenant/streams/$streamId': typeof TenantStreamsStreamIdRoute;
  '/$tenant/streams/new': typeof TenantStreamsNewRoute;
  '/$tenant/support/$ticketId': typeof TenantSupportTicketIdRoute;
  '/$tenant/support/new': typeof TenantSupportNewRoute;
  '/$tenant/tokens/new': typeof TenantTokensNewRoute;
  '/$tenant/workflows/editor': typeof TenantWorkflowsEditorRoute;
  '/$tenant/workspaces/$workspaceId': typeof TenantWorkspacesWorkspaceIdRoute;
  '/$tenant/workspaces/new': typeof TenantWorkspacesNewRoute;
  '/$tenant/agent-policies/': typeof TenantAgentPoliciesIndexRoute;
  '/$tenant/billing/': typeof TenantBillingIndexRoute;
  '/$tenant/bridges/': typeof TenantBridgesIndexRoute;
  '/$tenant/buckets/': typeof TenantBucketsIndexRoute;
  '/$tenant/catalog/': typeof TenantCatalogIndexRoute;
  '/$tenant/connections/': typeof TenantConnectionsIndexRoute;
  '/$tenant/editor/': typeof TenantEditorIndexRoute;
  '/$tenant/endpoints/': typeof TenantEndpointsIndexRoute;
  '/$tenant/experiments/': typeof TenantExperimentsIndexRoute;
  '/$tenant/firewall/': typeof TenantFirewallIndexRoute;
  '/$tenant/glossary/': typeof TenantGlossaryIndexRoute;
  '/$tenant/groups/': typeof TenantGroupsIndexRoute;
  '/$tenant/identity-providers/': typeof TenantIdentityProvidersIndexRoute;
  '/$tenant/jobs/': typeof TenantJobsIndexRoute;
  '/$tenant/libraries/': typeof TenantLibrariesIndexRoute;
  '/$tenant/lineage/': typeof TenantLineageIndexRoute;
  '/$tenant/llm/': typeof TenantLlmIndexRoute;
  '/$tenant/members/': typeof TenantMembersIndexRoute;
  '/$tenant/models/': typeof TenantModelsIndexRoute;
  '/$tenant/projects/': typeof TenantProjectsIndexRoute;
  '/$tenant/roles/': typeof TenantRolesIndexRoute;
  '/$tenant/runtimes/': typeof TenantRuntimesIndexRoute;
  '/$tenant/secrets/': typeof TenantSecretsIndexRoute;
  '/$tenant/sessions/': typeof TenantSessionsIndexRoute;
  '/$tenant/sql/': typeof TenantSqlIndexRoute;
  '/$tenant/streams/': typeof TenantStreamsIndexRoute;
  '/$tenant/support/': typeof TenantSupportIndexRoute;
  '/$tenant/tokens/': typeof TenantTokensIndexRoute;
  '/$tenant/triggers/': typeof TenantTriggersIndexRoute;
  '/$tenant/workflows/': typeof TenantWorkflowsIndexRoute;
  '/$tenant/workspaces/': typeof TenantWorkspacesIndexRoute;
  '/$tenant/billing/invoices/$invoiceId': typeof TenantBillingInvoicesInvoiceIdRoute;
  '/$tenant/billing/payment-methods/new': typeof TenantBillingPaymentMethodsNewRoute;
  '/$tenant/billing/transactions/$transactionId': typeof TenantBillingTransactionsTransactionIdRoute;
  '/$tenant/catalog/$layer/new': typeof TenantCatalogLayerNewRoute;
  '/$tenant/editor/templates/$templateName': typeof TenantEditorTemplatesTemplateNameRoute;
  '/$tenant/llm/budgets/$projectId': typeof TenantLlmBudgetsProjectIdRoute;
  '/$tenant/llm/models/$modelId': typeof TenantLlmModelsModelIdRoute;
  '/$tenant/llm/models/new': typeof TenantLlmModelsNewRoute;
  '/$tenant/llm/providers/$providerId': typeof TenantLlmProvidersProviderIdRoute;
  '/$tenant/llm/providers/new': typeof TenantLlmProvidersNewRoute;
  '/$tenant/projects/$projectId/activity': typeof TenantProjectsProjectIdActivityRoute;
  '/$tenant/projects/$projectId/agents': typeof TenantProjectsProjectIdAgentsRoute;
  '/$tenant/projects/$projectId/code-assistant': typeof TenantProjectsProjectIdCodeAssistantRoute;
  '/$tenant/projects/$projectId/costs': typeof TenantProjectsProjectIdCostsRoute;
  '/$tenant/projects/$projectId/llm-keys': typeof TenantProjectsProjectIdLlmKeysRoute;
  '/$tenant/projects/$projectId/metrics': typeof TenantProjectsProjectIdMetricsRoute;
  '/$tenant/projects/$projectId/settings': typeof TenantProjectsProjectIdSettingsRoute;
  '/$tenant/resources/devices/$deviceId': typeof TenantResourcesDevicesDeviceIdRoute;
  '/$tenant/resources/devices/enroll': typeof TenantResourcesDevicesEnrollRoute;
  '/$tenant/resources/infrastructures/$infrastructureId': typeof TenantResourcesInfrastructuresInfrastructureIdRoute;
  '/$tenant/resources/infrastructures/new': typeof TenantResourcesInfrastructuresNewRoute;
  '/$tenant/resources/instance-types/$instanceTypeId': typeof TenantResourcesInstanceTypesInstanceTypeIdRoute;
  '/$tenant/resources/quotas/$quotaKey': typeof TenantResourcesQuotasQuotaKeyRoute;
  '/$tenant/sql/$warehouseId/query': typeof TenantSqlWarehouseIdQueryRoute;
  '/$tenant/tokens/agents/$identityId': typeof TenantTokensAgentsIdentityIdRoute;
  '/$tenant/tokens/api/$applicationId': typeof TenantTokensApiApplicationIdRoute;
  '/$tenant/billing/invoices/': typeof TenantBillingInvoicesIndexRoute;
  '/$tenant/billing/payment-methods/': typeof TenantBillingPaymentMethodsIndexRoute;
  '/$tenant/billing/transactions/': typeof TenantBillingTransactionsIndexRoute;
  '/$tenant/catalog/$layer/': typeof TenantCatalogLayerIndexRoute;
  '/$tenant/editor/templates/': typeof TenantEditorTemplatesIndexRoute;
  '/$tenant/models/$modelId/': typeof TenantModelsModelIdIndexRoute;
  '/$tenant/projects/$projectId/': typeof TenantProjectsProjectIdIndexRoute;
  '/$tenant/resources/devices/': typeof TenantResourcesDevicesIndexRoute;
  '/$tenant/resources/infrastructures/': typeof TenantResourcesInfrastructuresIndexRoute;
  '/$tenant/resources/instance-types/': typeof TenantResourcesInstanceTypesIndexRoute;
  '/$tenant/resources/quotas/': typeof TenantResourcesQuotasIndexRoute;
  '/$tenant/runtimes/$runtimeId/': typeof TenantRuntimesRuntimeIdIndexRoute;
  '/$tenant/sql/$warehouseId/': typeof TenantSqlWarehouseIdIndexRoute;
  '/$tenant/catalog/$layer/$database/new': typeof TenantCatalogLayerDatabaseNewRoute;
  '/$tenant/jobs/$jobId/runs/$runId': typeof TenantJobsJobIdRunsRunIdRoute;
  '/$tenant/models/$modelId/versions/$versionId': typeof TenantModelsModelIdVersionsVersionIdRoute;
  '/$tenant/models/$modelId/versions/new': typeof TenantModelsModelIdVersionsNewRoute;
  '/$tenant/projects/$projectId/approvals/$approvalId': typeof TenantProjectsProjectIdApprovalsApprovalIdRoute;
  '/$tenant/projects/$projectId/assistant/$indexId': typeof TenantProjectsProjectIdAssistantIndexIdRoute;
  '/$tenant/projects/$projectId/assistant/new': typeof TenantProjectsProjectIdAssistantNewRoute;
  '/$tenant/projects/$projectId/connections/$connectionId': typeof TenantProjectsProjectIdConnectionsConnectionIdRoute;
  '/$tenant/projects/$projectId/connections/new': typeof TenantProjectsProjectIdConnectionsNewRoute;
  '/$tenant/projects/$projectId/endpoints/$endpointId': typeof TenantProjectsProjectIdEndpointsEndpointIdRoute;
  '/$tenant/projects/$projectId/endpoints/new': typeof TenantProjectsProjectIdEndpointsNewRoute;
  '/$tenant/projects/$projectId/experiments/new': typeof TenantProjectsProjectIdExperimentsNewRoute;
  '/$tenant/projects/$projectId/jobs/new': typeof TenantProjectsProjectIdJobsNewRoute;
  '/$tenant/projects/$projectId/members/new': typeof TenantProjectsProjectIdMembersNewRoute;
  '/$tenant/projects/$projectId/workflows/editor': typeof TenantProjectsProjectIdWorkflowsEditorRoute;
  '/$tenant/projects/$projectId/workflows/import-oozie': typeof TenantProjectsProjectIdWorkflowsImportOozieRoute;
  '/$tenant/projects/$projectId/workflows/new': typeof TenantProjectsProjectIdWorkflowsNewRoute;
  '/$tenant/runtimes/$runtimeId/builds/$buildId': typeof TenantRuntimesRuntimeIdBuildsBuildIdRoute;
  '/$tenant/runtimes/$runtimeId/builds/new': typeof TenantRuntimesRuntimeIdBuildsNewRoute;
  '/$tenant/runtimes/$runtimeId/versions/$versionId': typeof TenantRuntimesRuntimeIdVersionsVersionIdRoute;
  '/$tenant/runtimes/$runtimeId/versions/new': typeof TenantRuntimesRuntimeIdVersionsNewRoute;
  '/$tenant/catalog/$layer/$database/': typeof TenantCatalogLayerDatabaseIndexRoute;
  '/$tenant/projects/$projectId/assistant/': typeof TenantProjectsProjectIdAssistantIndexRoute;
  '/$tenant/projects/$projectId/connections/': typeof TenantProjectsProjectIdConnectionsIndexRoute;
  '/$tenant/projects/$projectId/endpoints/': typeof TenantProjectsProjectIdEndpointsIndexRoute;
  '/$tenant/projects/$projectId/experiments/': typeof TenantProjectsProjectIdExperimentsIndexRoute;
  '/$tenant/projects/$projectId/jobs/': typeof TenantProjectsProjectIdJobsIndexRoute;
  '/$tenant/projects/$projectId/members/': typeof TenantProjectsProjectIdMembersIndexRoute;
  '/$tenant/projects/$projectId/triggers/': typeof TenantProjectsProjectIdTriggersIndexRoute;
  '/$tenant/projects/$projectId/workflows/': typeof TenantProjectsProjectIdWorkflowsIndexRoute;
  '/$tenant/catalog/$layer/$database/$table/$field': typeof TenantCatalogLayerDatabaseTableFieldRoute;
  '/$tenant/catalog/$layer/$database/$table/new': typeof TenantCatalogLayerDatabaseTableNewRoute;
  '/$tenant/projects/$projectId/experiments/$experimentId/compare': typeof TenantProjectsProjectIdExperimentsExperimentIdCompareRoute;
  '/$tenant/projects/$projectId/workflows/$workflowId/editor': typeof TenantProjectsProjectIdWorkflowsWorkflowIdEditorRoute;
  '/$tenant/catalog/$layer/$database/$table/': typeof TenantCatalogLayerDatabaseTableIndexRoute;
  '/$tenant/projects/$projectId/experiments/$experimentId/': typeof TenantProjectsProjectIdExperimentsExperimentIdIndexRoute;
  '/$tenant/projects/$projectId/jobs/$jobId/': typeof TenantProjectsProjectIdJobsJobIdIndexRoute;
  '/$tenant/projects/$projectId/workflows/$workflowId/': typeof TenantProjectsProjectIdWorkflowsWorkflowIdIndexRoute;
  '/$tenant/projects/$projectId/experiments/$experimentId/runs/$runId': typeof TenantProjectsProjectIdExperimentsExperimentIdRunsRunIdRoute;
  '/$tenant/projects/$projectId/jobs/$jobId/runs/$runId': typeof TenantProjectsProjectIdJobsJobIdRunsRunIdRoute;
  '/$tenant/projects/$projectId/workflows/$workflowId/runs/$runId': typeof TenantProjectsProjectIdWorkflowsWorkflowIdRunsRunIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/$tenant'
    | '/callback'
    | '/login'
    | '/silent-callback'
    | '/$tenant/agents'
    | '/$tenant/api-docs'
    | '/$tenant/assistant'
    | '/$tenant/audit'
    | '/$tenant/audit-trail'
    | '/$tenant/branding'
    | '/$tenant/code-assistant'
    | '/$tenant/jupyter'
    | '/$tenant/llm-keys'
    | '/$tenant/me'
    | '/$tenant/mfa'
    | '/$tenant/notifications'
    | '/$tenant/overview'
    | '/$tenant/preferences'
    | '/$tenant/rstudio'
    | '/$tenant/search'
    | '/$tenant/secret-store'
    | '/$tenant/subscription'
    | '/$tenant/usage'
    | '/$tenant/vscode'
    | '/$tenant/'
    | '/$tenant/agent-policies/$policyId'
    | '/$tenant/agent-policies/new'
    | '/$tenant/billing/pricing'
    | '/$tenant/bridges/$bridgeId'
    | '/$tenant/bridges/new'
    | '/$tenant/buckets/$bucketId'
    | '/$tenant/buckets/new'
    | '/$tenant/catalog/new'
    | '/$tenant/editor/$graphId'
    | '/$tenant/editor/new'
    | '/$tenant/firewall/$ruleId'
    | '/$tenant/firewall/new'
    | '/$tenant/glossary/$termId'
    | '/$tenant/glossary/new'
    | '/$tenant/groups/$groupId'
    | '/$tenant/groups/new'
    | '/$tenant/identity-providers/$identityProviderId'
    | '/$tenant/identity-providers/new'
    | '/$tenant/lineage/graph'
    | '/$tenant/members/$userId'
    | '/$tenant/members/new'
    | '/$tenant/models/new'
    | '/$tenant/projects/new'
    | '/$tenant/roles/$roleId'
    | '/$tenant/roles/assignments'
    | '/$tenant/roles/new'
    | '/$tenant/runtimes/new'
    | '/$tenant/secrets/$secretId'
    | '/$tenant/secrets/new'
    | '/$tenant/sessions/$sessionId'
    | '/$tenant/sessions/new'
    | '/$tenant/sql/new'
    | '/$tenant/streams/$streamId'
    | '/$tenant/streams/new'
    | '/$tenant/support/$ticketId'
    | '/$tenant/support/new'
    | '/$tenant/tokens/new'
    | '/$tenant/workflows/editor'
    | '/$tenant/workspaces/$workspaceId'
    | '/$tenant/workspaces/new'
    | '/$tenant/agent-policies/'
    | '/$tenant/billing/'
    | '/$tenant/bridges/'
    | '/$tenant/buckets/'
    | '/$tenant/catalog/'
    | '/$tenant/connections/'
    | '/$tenant/editor/'
    | '/$tenant/endpoints/'
    | '/$tenant/experiments/'
    | '/$tenant/firewall/'
    | '/$tenant/glossary/'
    | '/$tenant/groups/'
    | '/$tenant/identity-providers/'
    | '/$tenant/jobs/'
    | '/$tenant/libraries/'
    | '/$tenant/lineage/'
    | '/$tenant/llm/'
    | '/$tenant/members/'
    | '/$tenant/models/'
    | '/$tenant/projects/'
    | '/$tenant/roles/'
    | '/$tenant/runtimes/'
    | '/$tenant/secrets/'
    | '/$tenant/sessions/'
    | '/$tenant/sql/'
    | '/$tenant/streams/'
    | '/$tenant/support/'
    | '/$tenant/tokens/'
    | '/$tenant/triggers/'
    | '/$tenant/workflows/'
    | '/$tenant/workspaces/'
    | '/$tenant/billing/invoices/$invoiceId'
    | '/$tenant/billing/payment-methods/new'
    | '/$tenant/billing/transactions/$transactionId'
    | '/$tenant/catalog/$layer/new'
    | '/$tenant/editor/templates/$templateName'
    | '/$tenant/llm/budgets/$projectId'
    | '/$tenant/llm/models/$modelId'
    | '/$tenant/llm/models/new'
    | '/$tenant/llm/providers/$providerId'
    | '/$tenant/llm/providers/new'
    | '/$tenant/projects/$projectId/activity'
    | '/$tenant/projects/$projectId/agents'
    | '/$tenant/projects/$projectId/code-assistant'
    | '/$tenant/projects/$projectId/costs'
    | '/$tenant/projects/$projectId/llm-keys'
    | '/$tenant/projects/$projectId/metrics'
    | '/$tenant/projects/$projectId/settings'
    | '/$tenant/resources/devices/$deviceId'
    | '/$tenant/resources/devices/enroll'
    | '/$tenant/resources/infrastructures/$infrastructureId'
    | '/$tenant/resources/infrastructures/new'
    | '/$tenant/resources/instance-types/$instanceTypeId'
    | '/$tenant/resources/quotas/$quotaKey'
    | '/$tenant/sql/$warehouseId/query'
    | '/$tenant/tokens/agents/$identityId'
    | '/$tenant/tokens/api/$applicationId'
    | '/$tenant/billing/invoices/'
    | '/$tenant/billing/payment-methods/'
    | '/$tenant/billing/transactions/'
    | '/$tenant/catalog/$layer/'
    | '/$tenant/editor/templates/'
    | '/$tenant/models/$modelId/'
    | '/$tenant/projects/$projectId/'
    | '/$tenant/resources/devices/'
    | '/$tenant/resources/infrastructures/'
    | '/$tenant/resources/instance-types/'
    | '/$tenant/resources/quotas/'
    | '/$tenant/runtimes/$runtimeId/'
    | '/$tenant/sql/$warehouseId/'
    | '/$tenant/catalog/$layer/$database/new'
    | '/$tenant/jobs/$jobId/runs/$runId'
    | '/$tenant/models/$modelId/versions/$versionId'
    | '/$tenant/models/$modelId/versions/new'
    | '/$tenant/projects/$projectId/approvals/$approvalId'
    | '/$tenant/projects/$projectId/assistant/$indexId'
    | '/$tenant/projects/$projectId/assistant/new'
    | '/$tenant/projects/$projectId/connections/$connectionId'
    | '/$tenant/projects/$projectId/connections/new'
    | '/$tenant/projects/$projectId/endpoints/$endpointId'
    | '/$tenant/projects/$projectId/endpoints/new'
    | '/$tenant/projects/$projectId/experiments/new'
    | '/$tenant/projects/$projectId/jobs/new'
    | '/$tenant/projects/$projectId/members/new'
    | '/$tenant/projects/$projectId/workflows/editor'
    | '/$tenant/projects/$projectId/workflows/import-oozie'
    | '/$tenant/projects/$projectId/workflows/new'
    | '/$tenant/runtimes/$runtimeId/builds/$buildId'
    | '/$tenant/runtimes/$runtimeId/builds/new'
    | '/$tenant/runtimes/$runtimeId/versions/$versionId'
    | '/$tenant/runtimes/$runtimeId/versions/new'
    | '/$tenant/catalog/$layer/$database/'
    | '/$tenant/projects/$projectId/assistant/'
    | '/$tenant/projects/$projectId/connections/'
    | '/$tenant/projects/$projectId/endpoints/'
    | '/$tenant/projects/$projectId/experiments/'
    | '/$tenant/projects/$projectId/jobs/'
    | '/$tenant/projects/$projectId/members/'
    | '/$tenant/projects/$projectId/triggers/'
    | '/$tenant/projects/$projectId/workflows/'
    | '/$tenant/catalog/$layer/$database/$table/$field'
    | '/$tenant/catalog/$layer/$database/$table/new'
    | '/$tenant/projects/$projectId/experiments/$experimentId/compare'
    | '/$tenant/projects/$projectId/workflows/$workflowId/editor'
    | '/$tenant/catalog/$layer/$database/$table/'
    | '/$tenant/projects/$projectId/experiments/$experimentId/'
    | '/$tenant/projects/$projectId/jobs/$jobId/'
    | '/$tenant/projects/$projectId/workflows/$workflowId/'
    | '/$tenant/projects/$projectId/experiments/$experimentId/runs/$runId'
    | '/$tenant/projects/$projectId/jobs/$jobId/runs/$runId'
    | '/$tenant/projects/$projectId/workflows/$workflowId/runs/$runId';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/callback'
    | '/login'
    | '/silent-callback'
    | '/$tenant/agents'
    | '/$tenant/api-docs'
    | '/$tenant/assistant'
    | '/$tenant/audit'
    | '/$tenant/audit-trail'
    | '/$tenant/branding'
    | '/$tenant/code-assistant'
    | '/$tenant/jupyter'
    | '/$tenant/llm-keys'
    | '/$tenant/me'
    | '/$tenant/mfa'
    | '/$tenant/notifications'
    | '/$tenant/overview'
    | '/$tenant/preferences'
    | '/$tenant/rstudio'
    | '/$tenant/search'
    | '/$tenant/secret-store'
    | '/$tenant/subscription'
    | '/$tenant/usage'
    | '/$tenant/vscode'
    | '/$tenant'
    | '/$tenant/agent-policies/$policyId'
    | '/$tenant/agent-policies/new'
    | '/$tenant/billing/pricing'
    | '/$tenant/bridges/$bridgeId'
    | '/$tenant/bridges/new'
    | '/$tenant/buckets/$bucketId'
    | '/$tenant/buckets/new'
    | '/$tenant/catalog/new'
    | '/$tenant/editor/$graphId'
    | '/$tenant/editor/new'
    | '/$tenant/firewall/$ruleId'
    | '/$tenant/firewall/new'
    | '/$tenant/glossary/$termId'
    | '/$tenant/glossary/new'
    | '/$tenant/groups/$groupId'
    | '/$tenant/groups/new'
    | '/$tenant/identity-providers/$identityProviderId'
    | '/$tenant/identity-providers/new'
    | '/$tenant/lineage/graph'
    | '/$tenant/members/$userId'
    | '/$tenant/members/new'
    | '/$tenant/models/new'
    | '/$tenant/projects/new'
    | '/$tenant/roles/$roleId'
    | '/$tenant/roles/assignments'
    | '/$tenant/roles/new'
    | '/$tenant/runtimes/new'
    | '/$tenant/secrets/$secretId'
    | '/$tenant/secrets/new'
    | '/$tenant/sessions/$sessionId'
    | '/$tenant/sessions/new'
    | '/$tenant/sql/new'
    | '/$tenant/streams/$streamId'
    | '/$tenant/streams/new'
    | '/$tenant/support/$ticketId'
    | '/$tenant/support/new'
    | '/$tenant/tokens/new'
    | '/$tenant/workflows/editor'
    | '/$tenant/workspaces/$workspaceId'
    | '/$tenant/workspaces/new'
    | '/$tenant/agent-policies'
    | '/$tenant/billing'
    | '/$tenant/bridges'
    | '/$tenant/buckets'
    | '/$tenant/catalog'
    | '/$tenant/connections'
    | '/$tenant/editor'
    | '/$tenant/endpoints'
    | '/$tenant/experiments'
    | '/$tenant/firewall'
    | '/$tenant/glossary'
    | '/$tenant/groups'
    | '/$tenant/identity-providers'
    | '/$tenant/jobs'
    | '/$tenant/libraries'
    | '/$tenant/lineage'
    | '/$tenant/llm'
    | '/$tenant/members'
    | '/$tenant/models'
    | '/$tenant/projects'
    | '/$tenant/roles'
    | '/$tenant/runtimes'
    | '/$tenant/secrets'
    | '/$tenant/sessions'
    | '/$tenant/sql'
    | '/$tenant/streams'
    | '/$tenant/support'
    | '/$tenant/tokens'
    | '/$tenant/triggers'
    | '/$tenant/workflows'
    | '/$tenant/workspaces'
    | '/$tenant/billing/invoices/$invoiceId'
    | '/$tenant/billing/payment-methods/new'
    | '/$tenant/billing/transactions/$transactionId'
    | '/$tenant/catalog/$layer/new'
    | '/$tenant/editor/templates/$templateName'
    | '/$tenant/llm/budgets/$projectId'
    | '/$tenant/llm/models/$modelId'
    | '/$tenant/llm/models/new'
    | '/$tenant/llm/providers/$providerId'
    | '/$tenant/llm/providers/new'
    | '/$tenant/projects/$projectId/activity'
    | '/$tenant/projects/$projectId/agents'
    | '/$tenant/projects/$projectId/code-assistant'
    | '/$tenant/projects/$projectId/costs'
    | '/$tenant/projects/$projectId/llm-keys'
    | '/$tenant/projects/$projectId/metrics'
    | '/$tenant/projects/$projectId/settings'
    | '/$tenant/resources/devices/$deviceId'
    | '/$tenant/resources/devices/enroll'
    | '/$tenant/resources/infrastructures/$infrastructureId'
    | '/$tenant/resources/infrastructures/new'
    | '/$tenant/resources/instance-types/$instanceTypeId'
    | '/$tenant/resources/quotas/$quotaKey'
    | '/$tenant/sql/$warehouseId/query'
    | '/$tenant/tokens/agents/$identityId'
    | '/$tenant/tokens/api/$applicationId'
    | '/$tenant/billing/invoices'
    | '/$tenant/billing/payment-methods'
    | '/$tenant/billing/transactions'
    | '/$tenant/catalog/$layer'
    | '/$tenant/editor/templates'
    | '/$tenant/models/$modelId'
    | '/$tenant/projects/$projectId'
    | '/$tenant/resources/devices'
    | '/$tenant/resources/infrastructures'
    | '/$tenant/resources/instance-types'
    | '/$tenant/resources/quotas'
    | '/$tenant/runtimes/$runtimeId'
    | '/$tenant/sql/$warehouseId'
    | '/$tenant/catalog/$layer/$database/new'
    | '/$tenant/jobs/$jobId/runs/$runId'
    | '/$tenant/models/$modelId/versions/$versionId'
    | '/$tenant/models/$modelId/versions/new'
    | '/$tenant/projects/$projectId/approvals/$approvalId'
    | '/$tenant/projects/$projectId/assistant/$indexId'
    | '/$tenant/projects/$projectId/assistant/new'
    | '/$tenant/projects/$projectId/connections/$connectionId'
    | '/$tenant/projects/$projectId/connections/new'
    | '/$tenant/projects/$projectId/endpoints/$endpointId'
    | '/$tenant/projects/$projectId/endpoints/new'
    | '/$tenant/projects/$projectId/experiments/new'
    | '/$tenant/projects/$projectId/jobs/new'
    | '/$tenant/projects/$projectId/members/new'
    | '/$tenant/projects/$projectId/workflows/editor'
    | '/$tenant/projects/$projectId/workflows/import-oozie'
    | '/$tenant/projects/$projectId/workflows/new'
    | '/$tenant/runtimes/$runtimeId/builds/$buildId'
    | '/$tenant/runtimes/$runtimeId/builds/new'
    | '/$tenant/runtimes/$runtimeId/versions/$versionId'
    | '/$tenant/runtimes/$runtimeId/versions/new'
    | '/$tenant/catalog/$layer/$database'
    | '/$tenant/projects/$projectId/assistant'
    | '/$tenant/projects/$projectId/connections'
    | '/$tenant/projects/$projectId/endpoints'
    | '/$tenant/projects/$projectId/experiments'
    | '/$tenant/projects/$projectId/jobs'
    | '/$tenant/projects/$projectId/members'
    | '/$tenant/projects/$projectId/triggers'
    | '/$tenant/projects/$projectId/workflows'
    | '/$tenant/catalog/$layer/$database/$table/$field'
    | '/$tenant/catalog/$layer/$database/$table/new'
    | '/$tenant/projects/$projectId/experiments/$experimentId/compare'
    | '/$tenant/projects/$projectId/workflows/$workflowId/editor'
    | '/$tenant/catalog/$layer/$database/$table'
    | '/$tenant/projects/$projectId/experiments/$experimentId'
    | '/$tenant/projects/$projectId/jobs/$jobId'
    | '/$tenant/projects/$projectId/workflows/$workflowId'
    | '/$tenant/projects/$projectId/experiments/$experimentId/runs/$runId'
    | '/$tenant/projects/$projectId/jobs/$jobId/runs/$runId'
    | '/$tenant/projects/$projectId/workflows/$workflowId/runs/$runId';
  id:
    | '__root__'
    | '/'
    | '/$tenant'
    | '/callback'
    | '/login'
    | '/silent-callback'
    | '/$tenant/agents'
    | '/$tenant/api-docs'
    | '/$tenant/assistant'
    | '/$tenant/audit'
    | '/$tenant/audit-trail'
    | '/$tenant/branding'
    | '/$tenant/code-assistant'
    | '/$tenant/jupyter'
    | '/$tenant/llm-keys'
    | '/$tenant/me'
    | '/$tenant/mfa'
    | '/$tenant/notifications'
    | '/$tenant/overview'
    | '/$tenant/preferences'
    | '/$tenant/rstudio'
    | '/$tenant/search'
    | '/$tenant/secret-store'
    | '/$tenant/subscription'
    | '/$tenant/usage'
    | '/$tenant/vscode'
    | '/$tenant/'
    | '/$tenant/agent-policies/$policyId'
    | '/$tenant/agent-policies/new'
    | '/$tenant/billing/pricing'
    | '/$tenant/bridges/$bridgeId'
    | '/$tenant/bridges/new'
    | '/$tenant/buckets/$bucketId'
    | '/$tenant/buckets/new'
    | '/$tenant/catalog/new'
    | '/$tenant/editor/$graphId'
    | '/$tenant/editor/new'
    | '/$tenant/firewall/$ruleId'
    | '/$tenant/firewall/new'
    | '/$tenant/glossary/$termId'
    | '/$tenant/glossary/new'
    | '/$tenant/groups/$groupId'
    | '/$tenant/groups/new'
    | '/$tenant/identity-providers/$identityProviderId'
    | '/$tenant/identity-providers/new'
    | '/$tenant/lineage/graph'
    | '/$tenant/members/$userId'
    | '/$tenant/members/new'
    | '/$tenant/models/new'
    | '/$tenant/projects/new'
    | '/$tenant/roles/$roleId'
    | '/$tenant/roles/assignments'
    | '/$tenant/roles/new'
    | '/$tenant/runtimes/new'
    | '/$tenant/secrets/$secretId'
    | '/$tenant/secrets/new'
    | '/$tenant/sessions/$sessionId'
    | '/$tenant/sessions/new'
    | '/$tenant/sql/new'
    | '/$tenant/streams/$streamId'
    | '/$tenant/streams/new'
    | '/$tenant/support/$ticketId'
    | '/$tenant/support/new'
    | '/$tenant/tokens/new'
    | '/$tenant/workflows/editor'
    | '/$tenant/workspaces/$workspaceId'
    | '/$tenant/workspaces/new'
    | '/$tenant/agent-policies/'
    | '/$tenant/billing/'
    | '/$tenant/bridges/'
    | '/$tenant/buckets/'
    | '/$tenant/catalog/'
    | '/$tenant/connections/'
    | '/$tenant/editor/'
    | '/$tenant/endpoints/'
    | '/$tenant/experiments/'
    | '/$tenant/firewall/'
    | '/$tenant/glossary/'
    | '/$tenant/groups/'
    | '/$tenant/identity-providers/'
    | '/$tenant/jobs/'
    | '/$tenant/libraries/'
    | '/$tenant/lineage/'
    | '/$tenant/llm/'
    | '/$tenant/members/'
    | '/$tenant/models/'
    | '/$tenant/projects/'
    | '/$tenant/roles/'
    | '/$tenant/runtimes/'
    | '/$tenant/secrets/'
    | '/$tenant/sessions/'
    | '/$tenant/sql/'
    | '/$tenant/streams/'
    | '/$tenant/support/'
    | '/$tenant/tokens/'
    | '/$tenant/triggers/'
    | '/$tenant/workflows/'
    | '/$tenant/workspaces/'
    | '/$tenant/billing/invoices/$invoiceId'
    | '/$tenant/billing/payment-methods/new'
    | '/$tenant/billing/transactions/$transactionId'
    | '/$tenant/catalog/$layer/new'
    | '/$tenant/editor/templates/$templateName'
    | '/$tenant/llm/budgets/$projectId'
    | '/$tenant/llm/models/$modelId'
    | '/$tenant/llm/models/new'
    | '/$tenant/llm/providers/$providerId'
    | '/$tenant/llm/providers/new'
    | '/$tenant/projects/$projectId/activity'
    | '/$tenant/projects/$projectId/agents'
    | '/$tenant/projects/$projectId/code-assistant'
    | '/$tenant/projects/$projectId/costs'
    | '/$tenant/projects/$projectId/llm-keys'
    | '/$tenant/projects/$projectId/metrics'
    | '/$tenant/projects/$projectId/settings'
    | '/$tenant/resources/devices/$deviceId'
    | '/$tenant/resources/devices/enroll'
    | '/$tenant/resources/infrastructures/$infrastructureId'
    | '/$tenant/resources/infrastructures/new'
    | '/$tenant/resources/instance-types/$instanceTypeId'
    | '/$tenant/resources/quotas/$quotaKey'
    | '/$tenant/sql/$warehouseId/query'
    | '/$tenant/tokens/agents/$identityId'
    | '/$tenant/tokens/api/$applicationId'
    | '/$tenant/billing/invoices/'
    | '/$tenant/billing/payment-methods/'
    | '/$tenant/billing/transactions/'
    | '/$tenant/catalog/$layer/'
    | '/$tenant/editor/templates/'
    | '/$tenant/models/$modelId/'
    | '/$tenant/projects/$projectId/'
    | '/$tenant/resources/devices/'
    | '/$tenant/resources/infrastructures/'
    | '/$tenant/resources/instance-types/'
    | '/$tenant/resources/quotas/'
    | '/$tenant/runtimes/$runtimeId/'
    | '/$tenant/sql/$warehouseId/'
    | '/$tenant/catalog/$layer/$database/new'
    | '/$tenant/jobs/$jobId/runs/$runId'
    | '/$tenant/models/$modelId/versions/$versionId'
    | '/$tenant/models/$modelId/versions/new'
    | '/$tenant/projects/$projectId/approvals/$approvalId'
    | '/$tenant/projects/$projectId/assistant/$indexId'
    | '/$tenant/projects/$projectId/assistant/new'
    | '/$tenant/projects/$projectId/connections/$connectionId'
    | '/$tenant/projects/$projectId/connections/new'
    | '/$tenant/projects/$projectId/endpoints/$endpointId'
    | '/$tenant/projects/$projectId/endpoints/new'
    | '/$tenant/projects/$projectId/experiments/new'
    | '/$tenant/projects/$projectId/jobs/new'
    | '/$tenant/projects/$projectId/members/new'
    | '/$tenant/projects/$projectId/workflows/editor'
    | '/$tenant/projects/$projectId/workflows/import-oozie'
    | '/$tenant/projects/$projectId/workflows/new'
    | '/$tenant/runtimes/$runtimeId/builds/$buildId'
    | '/$tenant/runtimes/$runtimeId/builds/new'
    | '/$tenant/runtimes/$runtimeId/versions/$versionId'
    | '/$tenant/runtimes/$runtimeId/versions/new'
    | '/$tenant/catalog/$layer/$database/'
    | '/$tenant/projects/$projectId/assistant/'
    | '/$tenant/projects/$projectId/connections/'
    | '/$tenant/projects/$projectId/endpoints/'
    | '/$tenant/projects/$projectId/experiments/'
    | '/$tenant/projects/$projectId/jobs/'
    | '/$tenant/projects/$projectId/members/'
    | '/$tenant/projects/$projectId/triggers/'
    | '/$tenant/projects/$projectId/workflows/'
    | '/$tenant/catalog/$layer/$database/$table/$field'
    | '/$tenant/catalog/$layer/$database/$table/new'
    | '/$tenant/projects/$projectId/experiments/$experimentId/compare'
    | '/$tenant/projects/$projectId/workflows/$workflowId/editor'
    | '/$tenant/catalog/$layer/$database/$table/'
    | '/$tenant/projects/$projectId/experiments/$experimentId/'
    | '/$tenant/projects/$projectId/jobs/$jobId/'
    | '/$tenant/projects/$projectId/workflows/$workflowId/'
    | '/$tenant/projects/$projectId/experiments/$experimentId/runs/$runId'
    | '/$tenant/projects/$projectId/jobs/$jobId/runs/$runId'
    | '/$tenant/projects/$projectId/workflows/$workflowId/runs/$runId';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  TenantRoute: typeof TenantRouteWithChildren;
  CallbackRoute: typeof CallbackRoute;
  LoginRoute: typeof LoginRoute;
  SilentCallbackRoute: typeof SilentCallbackRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/$tenant': {
      id: '/$tenant';
      path: '/$tenant';
      fullPath: '/$tenant';
      preLoaderRoute: typeof TenantRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/callback': {
      id: '/callback';
      path: '/callback';
      fullPath: '/callback';
      preLoaderRoute: typeof CallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/silent-callback': {
      id: '/silent-callback';
      path: '/silent-callback';
      fullPath: '/silent-callback';
      preLoaderRoute: typeof SilentCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/$tenant/': {
      id: '/$tenant/';
      path: '/';
      fullPath: '/$tenant/';
      preLoaderRoute: typeof TenantIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/agents': {
      id: '/$tenant/agents';
      path: '/agents';
      fullPath: '/$tenant/agents';
      preLoaderRoute: typeof TenantAgentsRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/api-docs': {
      id: '/$tenant/api-docs';
      path: '/api-docs';
      fullPath: '/$tenant/api-docs';
      preLoaderRoute: typeof TenantApiDocsRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/assistant': {
      id: '/$tenant/assistant';
      path: '/assistant';
      fullPath: '/$tenant/assistant';
      preLoaderRoute: typeof TenantAssistantRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/audit': {
      id: '/$tenant/audit';
      path: '/audit';
      fullPath: '/$tenant/audit';
      preLoaderRoute: typeof TenantAuditRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/audit-trail': {
      id: '/$tenant/audit-trail';
      path: '/audit-trail';
      fullPath: '/$tenant/audit-trail';
      preLoaderRoute: typeof TenantAuditTrailRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/branding': {
      id: '/$tenant/branding';
      path: '/branding';
      fullPath: '/$tenant/branding';
      preLoaderRoute: typeof TenantBrandingRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/code-assistant': {
      id: '/$tenant/code-assistant';
      path: '/code-assistant';
      fullPath: '/$tenant/code-assistant';
      preLoaderRoute: typeof TenantCodeAssistantRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/jupyter': {
      id: '/$tenant/jupyter';
      path: '/jupyter';
      fullPath: '/$tenant/jupyter';
      preLoaderRoute: typeof TenantJupyterRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/llm-keys': {
      id: '/$tenant/llm-keys';
      path: '/llm-keys';
      fullPath: '/$tenant/llm-keys';
      preLoaderRoute: typeof TenantLlmKeysRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/me': {
      id: '/$tenant/me';
      path: '/me';
      fullPath: '/$tenant/me';
      preLoaderRoute: typeof TenantMeRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/mfa': {
      id: '/$tenant/mfa';
      path: '/mfa';
      fullPath: '/$tenant/mfa';
      preLoaderRoute: typeof TenantMfaRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/notifications': {
      id: '/$tenant/notifications';
      path: '/notifications';
      fullPath: '/$tenant/notifications';
      preLoaderRoute: typeof TenantNotificationsRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/overview': {
      id: '/$tenant/overview';
      path: '/overview';
      fullPath: '/$tenant/overview';
      preLoaderRoute: typeof TenantOverviewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/preferences': {
      id: '/$tenant/preferences';
      path: '/preferences';
      fullPath: '/$tenant/preferences';
      preLoaderRoute: typeof TenantPreferencesRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/rstudio': {
      id: '/$tenant/rstudio';
      path: '/rstudio';
      fullPath: '/$tenant/rstudio';
      preLoaderRoute: typeof TenantRstudioRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/search': {
      id: '/$tenant/search';
      path: '/search';
      fullPath: '/$tenant/search';
      preLoaderRoute: typeof TenantSearchRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/secret-store': {
      id: '/$tenant/secret-store';
      path: '/secret-store';
      fullPath: '/$tenant/secret-store';
      preLoaderRoute: typeof TenantSecretStoreRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/subscription': {
      id: '/$tenant/subscription';
      path: '/subscription';
      fullPath: '/$tenant/subscription';
      preLoaderRoute: typeof TenantSubscriptionRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/usage': {
      id: '/$tenant/usage';
      path: '/usage';
      fullPath: '/$tenant/usage';
      preLoaderRoute: typeof TenantUsageRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/vscode': {
      id: '/$tenant/vscode';
      path: '/vscode';
      fullPath: '/$tenant/vscode';
      preLoaderRoute: typeof TenantVscodeRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/agent-policies/': {
      id: '/$tenant/agent-policies/';
      path: '/agent-policies';
      fullPath: '/$tenant/agent-policies/';
      preLoaderRoute: typeof TenantAgentPoliciesIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/agent-policies/$policyId': {
      id: '/$tenant/agent-policies/$policyId';
      path: '/agent-policies/$policyId';
      fullPath: '/$tenant/agent-policies/$policyId';
      preLoaderRoute: typeof TenantAgentPoliciesPolicyIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/agent-policies/new': {
      id: '/$tenant/agent-policies/new';
      path: '/agent-policies/new';
      fullPath: '/$tenant/agent-policies/new';
      preLoaderRoute: typeof TenantAgentPoliciesNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/billing/': {
      id: '/$tenant/billing/';
      path: '/billing';
      fullPath: '/$tenant/billing/';
      preLoaderRoute: typeof TenantBillingIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/billing/pricing': {
      id: '/$tenant/billing/pricing';
      path: '/billing/pricing';
      fullPath: '/$tenant/billing/pricing';
      preLoaderRoute: typeof TenantBillingPricingRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/bridges/': {
      id: '/$tenant/bridges/';
      path: '/bridges';
      fullPath: '/$tenant/bridges/';
      preLoaderRoute: typeof TenantBridgesIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/bridges/$bridgeId': {
      id: '/$tenant/bridges/$bridgeId';
      path: '/bridges/$bridgeId';
      fullPath: '/$tenant/bridges/$bridgeId';
      preLoaderRoute: typeof TenantBridgesBridgeIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/bridges/new': {
      id: '/$tenant/bridges/new';
      path: '/bridges/new';
      fullPath: '/$tenant/bridges/new';
      preLoaderRoute: typeof TenantBridgesNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/buckets/': {
      id: '/$tenant/buckets/';
      path: '/buckets';
      fullPath: '/$tenant/buckets/';
      preLoaderRoute: typeof TenantBucketsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/buckets/$bucketId': {
      id: '/$tenant/buckets/$bucketId';
      path: '/buckets/$bucketId';
      fullPath: '/$tenant/buckets/$bucketId';
      preLoaderRoute: typeof TenantBucketsBucketIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/buckets/new': {
      id: '/$tenant/buckets/new';
      path: '/buckets/new';
      fullPath: '/$tenant/buckets/new';
      preLoaderRoute: typeof TenantBucketsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/catalog/': {
      id: '/$tenant/catalog/';
      path: '/catalog';
      fullPath: '/$tenant/catalog/';
      preLoaderRoute: typeof TenantCatalogIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/catalog/new': {
      id: '/$tenant/catalog/new';
      path: '/catalog/new';
      fullPath: '/$tenant/catalog/new';
      preLoaderRoute: typeof TenantCatalogNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/connections/': {
      id: '/$tenant/connections/';
      path: '/connections';
      fullPath: '/$tenant/connections/';
      preLoaderRoute: typeof TenantConnectionsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/editor/': {
      id: '/$tenant/editor/';
      path: '/editor';
      fullPath: '/$tenant/editor/';
      preLoaderRoute: typeof TenantEditorIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/editor/$graphId': {
      id: '/$tenant/editor/$graphId';
      path: '/editor/$graphId';
      fullPath: '/$tenant/editor/$graphId';
      preLoaderRoute: typeof TenantEditorGraphIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/editor/new': {
      id: '/$tenant/editor/new';
      path: '/editor/new';
      fullPath: '/$tenant/editor/new';
      preLoaderRoute: typeof TenantEditorNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/endpoints/': {
      id: '/$tenant/endpoints/';
      path: '/endpoints';
      fullPath: '/$tenant/endpoints/';
      preLoaderRoute: typeof TenantEndpointsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/experiments/': {
      id: '/$tenant/experiments/';
      path: '/experiments';
      fullPath: '/$tenant/experiments/';
      preLoaderRoute: typeof TenantExperimentsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/firewall/': {
      id: '/$tenant/firewall/';
      path: '/firewall';
      fullPath: '/$tenant/firewall/';
      preLoaderRoute: typeof TenantFirewallIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/firewall/$ruleId': {
      id: '/$tenant/firewall/$ruleId';
      path: '/firewall/$ruleId';
      fullPath: '/$tenant/firewall/$ruleId';
      preLoaderRoute: typeof TenantFirewallRuleIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/firewall/new': {
      id: '/$tenant/firewall/new';
      path: '/firewall/new';
      fullPath: '/$tenant/firewall/new';
      preLoaderRoute: typeof TenantFirewallNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/glossary/': {
      id: '/$tenant/glossary/';
      path: '/glossary';
      fullPath: '/$tenant/glossary/';
      preLoaderRoute: typeof TenantGlossaryIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/glossary/$termId': {
      id: '/$tenant/glossary/$termId';
      path: '/glossary/$termId';
      fullPath: '/$tenant/glossary/$termId';
      preLoaderRoute: typeof TenantGlossaryTermIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/glossary/new': {
      id: '/$tenant/glossary/new';
      path: '/glossary/new';
      fullPath: '/$tenant/glossary/new';
      preLoaderRoute: typeof TenantGlossaryNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/groups/': {
      id: '/$tenant/groups/';
      path: '/groups';
      fullPath: '/$tenant/groups/';
      preLoaderRoute: typeof TenantGroupsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/groups/$groupId': {
      id: '/$tenant/groups/$groupId';
      path: '/groups/$groupId';
      fullPath: '/$tenant/groups/$groupId';
      preLoaderRoute: typeof TenantGroupsGroupIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/groups/new': {
      id: '/$tenant/groups/new';
      path: '/groups/new';
      fullPath: '/$tenant/groups/new';
      preLoaderRoute: typeof TenantGroupsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/identity-providers/': {
      id: '/$tenant/identity-providers/';
      path: '/identity-providers';
      fullPath: '/$tenant/identity-providers/';
      preLoaderRoute: typeof TenantIdentityProvidersIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/identity-providers/$identityProviderId': {
      id: '/$tenant/identity-providers/$identityProviderId';
      path: '/identity-providers/$identityProviderId';
      fullPath: '/$tenant/identity-providers/$identityProviderId';
      preLoaderRoute: typeof TenantIdentityProvidersIdentityProviderIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/identity-providers/new': {
      id: '/$tenant/identity-providers/new';
      path: '/identity-providers/new';
      fullPath: '/$tenant/identity-providers/new';
      preLoaderRoute: typeof TenantIdentityProvidersNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/jobs/': {
      id: '/$tenant/jobs/';
      path: '/jobs';
      fullPath: '/$tenant/jobs/';
      preLoaderRoute: typeof TenantJobsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/libraries/': {
      id: '/$tenant/libraries/';
      path: '/libraries';
      fullPath: '/$tenant/libraries/';
      preLoaderRoute: typeof TenantLibrariesIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/lineage/': {
      id: '/$tenant/lineage/';
      path: '/lineage';
      fullPath: '/$tenant/lineage/';
      preLoaderRoute: typeof TenantLineageIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/lineage/graph': {
      id: '/$tenant/lineage/graph';
      path: '/lineage/graph';
      fullPath: '/$tenant/lineage/graph';
      preLoaderRoute: typeof TenantLineageGraphRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/llm/': {
      id: '/$tenant/llm/';
      path: '/llm';
      fullPath: '/$tenant/llm/';
      preLoaderRoute: typeof TenantLlmIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/members/': {
      id: '/$tenant/members/';
      path: '/members';
      fullPath: '/$tenant/members/';
      preLoaderRoute: typeof TenantMembersIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/members/$userId': {
      id: '/$tenant/members/$userId';
      path: '/members/$userId';
      fullPath: '/$tenant/members/$userId';
      preLoaderRoute: typeof TenantMembersUserIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/members/new': {
      id: '/$tenant/members/new';
      path: '/members/new';
      fullPath: '/$tenant/members/new';
      preLoaderRoute: typeof TenantMembersNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/models/': {
      id: '/$tenant/models/';
      path: '/models';
      fullPath: '/$tenant/models/';
      preLoaderRoute: typeof TenantModelsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/models/new': {
      id: '/$tenant/models/new';
      path: '/models/new';
      fullPath: '/$tenant/models/new';
      preLoaderRoute: typeof TenantModelsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/': {
      id: '/$tenant/projects/';
      path: '/projects';
      fullPath: '/$tenant/projects/';
      preLoaderRoute: typeof TenantProjectsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/new': {
      id: '/$tenant/projects/new';
      path: '/projects/new';
      fullPath: '/$tenant/projects/new';
      preLoaderRoute: typeof TenantProjectsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/roles/': {
      id: '/$tenant/roles/';
      path: '/roles';
      fullPath: '/$tenant/roles/';
      preLoaderRoute: typeof TenantRolesIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/roles/$roleId': {
      id: '/$tenant/roles/$roleId';
      path: '/roles/$roleId';
      fullPath: '/$tenant/roles/$roleId';
      preLoaderRoute: typeof TenantRolesRoleIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/roles/assignments': {
      id: '/$tenant/roles/assignments';
      path: '/roles/assignments';
      fullPath: '/$tenant/roles/assignments';
      preLoaderRoute: typeof TenantRolesAssignmentsRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/roles/new': {
      id: '/$tenant/roles/new';
      path: '/roles/new';
      fullPath: '/$tenant/roles/new';
      preLoaderRoute: typeof TenantRolesNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/runtimes/': {
      id: '/$tenant/runtimes/';
      path: '/runtimes';
      fullPath: '/$tenant/runtimes/';
      preLoaderRoute: typeof TenantRuntimesIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/runtimes/new': {
      id: '/$tenant/runtimes/new';
      path: '/runtimes/new';
      fullPath: '/$tenant/runtimes/new';
      preLoaderRoute: typeof TenantRuntimesNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/secrets/': {
      id: '/$tenant/secrets/';
      path: '/secrets';
      fullPath: '/$tenant/secrets/';
      preLoaderRoute: typeof TenantSecretsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/secrets/$secretId': {
      id: '/$tenant/secrets/$secretId';
      path: '/secrets/$secretId';
      fullPath: '/$tenant/secrets/$secretId';
      preLoaderRoute: typeof TenantSecretsSecretIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/secrets/new': {
      id: '/$tenant/secrets/new';
      path: '/secrets/new';
      fullPath: '/$tenant/secrets/new';
      preLoaderRoute: typeof TenantSecretsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/sessions/': {
      id: '/$tenant/sessions/';
      path: '/sessions';
      fullPath: '/$tenant/sessions/';
      preLoaderRoute: typeof TenantSessionsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/sessions/$sessionId': {
      id: '/$tenant/sessions/$sessionId';
      path: '/sessions/$sessionId';
      fullPath: '/$tenant/sessions/$sessionId';
      preLoaderRoute: typeof TenantSessionsSessionIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/sessions/new': {
      id: '/$tenant/sessions/new';
      path: '/sessions/new';
      fullPath: '/$tenant/sessions/new';
      preLoaderRoute: typeof TenantSessionsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/sql/': {
      id: '/$tenant/sql/';
      path: '/sql';
      fullPath: '/$tenant/sql/';
      preLoaderRoute: typeof TenantSqlIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/sql/new': {
      id: '/$tenant/sql/new';
      path: '/sql/new';
      fullPath: '/$tenant/sql/new';
      preLoaderRoute: typeof TenantSqlNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/streams/': {
      id: '/$tenant/streams/';
      path: '/streams';
      fullPath: '/$tenant/streams/';
      preLoaderRoute: typeof TenantStreamsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/streams/$streamId': {
      id: '/$tenant/streams/$streamId';
      path: '/streams/$streamId';
      fullPath: '/$tenant/streams/$streamId';
      preLoaderRoute: typeof TenantStreamsStreamIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/streams/new': {
      id: '/$tenant/streams/new';
      path: '/streams/new';
      fullPath: '/$tenant/streams/new';
      preLoaderRoute: typeof TenantStreamsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/support/': {
      id: '/$tenant/support/';
      path: '/support';
      fullPath: '/$tenant/support/';
      preLoaderRoute: typeof TenantSupportIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/support/$ticketId': {
      id: '/$tenant/support/$ticketId';
      path: '/support/$ticketId';
      fullPath: '/$tenant/support/$ticketId';
      preLoaderRoute: typeof TenantSupportTicketIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/support/new': {
      id: '/$tenant/support/new';
      path: '/support/new';
      fullPath: '/$tenant/support/new';
      preLoaderRoute: typeof TenantSupportNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/tokens/': {
      id: '/$tenant/tokens/';
      path: '/tokens';
      fullPath: '/$tenant/tokens/';
      preLoaderRoute: typeof TenantTokensIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/tokens/new': {
      id: '/$tenant/tokens/new';
      path: '/tokens/new';
      fullPath: '/$tenant/tokens/new';
      preLoaderRoute: typeof TenantTokensNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/triggers/': {
      id: '/$tenant/triggers/';
      path: '/triggers';
      fullPath: '/$tenant/triggers/';
      preLoaderRoute: typeof TenantTriggersIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/workflows/': {
      id: '/$tenant/workflows/';
      path: '/workflows';
      fullPath: '/$tenant/workflows/';
      preLoaderRoute: typeof TenantWorkflowsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/workflows/editor': {
      id: '/$tenant/workflows/editor';
      path: '/workflows/editor';
      fullPath: '/$tenant/workflows/editor';
      preLoaderRoute: typeof TenantWorkflowsEditorRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/workspaces/': {
      id: '/$tenant/workspaces/';
      path: '/workspaces';
      fullPath: '/$tenant/workspaces/';
      preLoaderRoute: typeof TenantWorkspacesIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/workspaces/$workspaceId': {
      id: '/$tenant/workspaces/$workspaceId';
      path: '/workspaces/$workspaceId';
      fullPath: '/$tenant/workspaces/$workspaceId';
      preLoaderRoute: typeof TenantWorkspacesWorkspaceIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/workspaces/new': {
      id: '/$tenant/workspaces/new';
      path: '/workspaces/new';
      fullPath: '/$tenant/workspaces/new';
      preLoaderRoute: typeof TenantWorkspacesNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/billing/invoices/': {
      id: '/$tenant/billing/invoices/';
      path: '/billing/invoices';
      fullPath: '/$tenant/billing/invoices/';
      preLoaderRoute: typeof TenantBillingInvoicesIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/billing/invoices/$invoiceId': {
      id: '/$tenant/billing/invoices/$invoiceId';
      path: '/billing/invoices/$invoiceId';
      fullPath: '/$tenant/billing/invoices/$invoiceId';
      preLoaderRoute: typeof TenantBillingInvoicesInvoiceIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/billing/payment-methods/': {
      id: '/$tenant/billing/payment-methods/';
      path: '/billing/payment-methods';
      fullPath: '/$tenant/billing/payment-methods/';
      preLoaderRoute: typeof TenantBillingPaymentMethodsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/billing/payment-methods/new': {
      id: '/$tenant/billing/payment-methods/new';
      path: '/billing/payment-methods/new';
      fullPath: '/$tenant/billing/payment-methods/new';
      preLoaderRoute: typeof TenantBillingPaymentMethodsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/billing/transactions/': {
      id: '/$tenant/billing/transactions/';
      path: '/billing/transactions';
      fullPath: '/$tenant/billing/transactions/';
      preLoaderRoute: typeof TenantBillingTransactionsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/billing/transactions/$transactionId': {
      id: '/$tenant/billing/transactions/$transactionId';
      path: '/billing/transactions/$transactionId';
      fullPath: '/$tenant/billing/transactions/$transactionId';
      preLoaderRoute: typeof TenantBillingTransactionsTransactionIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/catalog/$layer/': {
      id: '/$tenant/catalog/$layer/';
      path: '/catalog/$layer';
      fullPath: '/$tenant/catalog/$layer/';
      preLoaderRoute: typeof TenantCatalogLayerIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/catalog/$layer/new': {
      id: '/$tenant/catalog/$layer/new';
      path: '/catalog/$layer/new';
      fullPath: '/$tenant/catalog/$layer/new';
      preLoaderRoute: typeof TenantCatalogLayerNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/editor/templates/': {
      id: '/$tenant/editor/templates/';
      path: '/editor/templates';
      fullPath: '/$tenant/editor/templates/';
      preLoaderRoute: typeof TenantEditorTemplatesIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/editor/templates/$templateName': {
      id: '/$tenant/editor/templates/$templateName';
      path: '/editor/templates/$templateName';
      fullPath: '/$tenant/editor/templates/$templateName';
      preLoaderRoute: typeof TenantEditorTemplatesTemplateNameRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/llm/budgets/$projectId': {
      id: '/$tenant/llm/budgets/$projectId';
      path: '/llm/budgets/$projectId';
      fullPath: '/$tenant/llm/budgets/$projectId';
      preLoaderRoute: typeof TenantLlmBudgetsProjectIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/llm/models/$modelId': {
      id: '/$tenant/llm/models/$modelId';
      path: '/llm/models/$modelId';
      fullPath: '/$tenant/llm/models/$modelId';
      preLoaderRoute: typeof TenantLlmModelsModelIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/llm/models/new': {
      id: '/$tenant/llm/models/new';
      path: '/llm/models/new';
      fullPath: '/$tenant/llm/models/new';
      preLoaderRoute: typeof TenantLlmModelsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/llm/providers/$providerId': {
      id: '/$tenant/llm/providers/$providerId';
      path: '/llm/providers/$providerId';
      fullPath: '/$tenant/llm/providers/$providerId';
      preLoaderRoute: typeof TenantLlmProvidersProviderIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/llm/providers/new': {
      id: '/$tenant/llm/providers/new';
      path: '/llm/providers/new';
      fullPath: '/$tenant/llm/providers/new';
      preLoaderRoute: typeof TenantLlmProvidersNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/models/$modelId/': {
      id: '/$tenant/models/$modelId/';
      path: '/models/$modelId';
      fullPath: '/$tenant/models/$modelId/';
      preLoaderRoute: typeof TenantModelsModelIdIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/': {
      id: '/$tenant/projects/$projectId/';
      path: '/projects/$projectId';
      fullPath: '/$tenant/projects/$projectId/';
      preLoaderRoute: typeof TenantProjectsProjectIdIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/activity': {
      id: '/$tenant/projects/$projectId/activity';
      path: '/projects/$projectId/activity';
      fullPath: '/$tenant/projects/$projectId/activity';
      preLoaderRoute: typeof TenantProjectsProjectIdActivityRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/agents': {
      id: '/$tenant/projects/$projectId/agents';
      path: '/projects/$projectId/agents';
      fullPath: '/$tenant/projects/$projectId/agents';
      preLoaderRoute: typeof TenantProjectsProjectIdAgentsRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/code-assistant': {
      id: '/$tenant/projects/$projectId/code-assistant';
      path: '/projects/$projectId/code-assistant';
      fullPath: '/$tenant/projects/$projectId/code-assistant';
      preLoaderRoute: typeof TenantProjectsProjectIdCodeAssistantRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/costs': {
      id: '/$tenant/projects/$projectId/costs';
      path: '/projects/$projectId/costs';
      fullPath: '/$tenant/projects/$projectId/costs';
      preLoaderRoute: typeof TenantProjectsProjectIdCostsRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/llm-keys': {
      id: '/$tenant/projects/$projectId/llm-keys';
      path: '/projects/$projectId/llm-keys';
      fullPath: '/$tenant/projects/$projectId/llm-keys';
      preLoaderRoute: typeof TenantProjectsProjectIdLlmKeysRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/metrics': {
      id: '/$tenant/projects/$projectId/metrics';
      path: '/projects/$projectId/metrics';
      fullPath: '/$tenant/projects/$projectId/metrics';
      preLoaderRoute: typeof TenantProjectsProjectIdMetricsRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/settings': {
      id: '/$tenant/projects/$projectId/settings';
      path: '/projects/$projectId/settings';
      fullPath: '/$tenant/projects/$projectId/settings';
      preLoaderRoute: typeof TenantProjectsProjectIdSettingsRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/resources/devices/': {
      id: '/$tenant/resources/devices/';
      path: '/resources/devices';
      fullPath: '/$tenant/resources/devices/';
      preLoaderRoute: typeof TenantResourcesDevicesIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/resources/devices/$deviceId': {
      id: '/$tenant/resources/devices/$deviceId';
      path: '/resources/devices/$deviceId';
      fullPath: '/$tenant/resources/devices/$deviceId';
      preLoaderRoute: typeof TenantResourcesDevicesDeviceIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/resources/devices/enroll': {
      id: '/$tenant/resources/devices/enroll';
      path: '/resources/devices/enroll';
      fullPath: '/$tenant/resources/devices/enroll';
      preLoaderRoute: typeof TenantResourcesDevicesEnrollRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/resources/infrastructures/': {
      id: '/$tenant/resources/infrastructures/';
      path: '/resources/infrastructures';
      fullPath: '/$tenant/resources/infrastructures/';
      preLoaderRoute: typeof TenantResourcesInfrastructuresIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/resources/infrastructures/$infrastructureId': {
      id: '/$tenant/resources/infrastructures/$infrastructureId';
      path: '/resources/infrastructures/$infrastructureId';
      fullPath: '/$tenant/resources/infrastructures/$infrastructureId';
      preLoaderRoute: typeof TenantResourcesInfrastructuresInfrastructureIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/resources/infrastructures/new': {
      id: '/$tenant/resources/infrastructures/new';
      path: '/resources/infrastructures/new';
      fullPath: '/$tenant/resources/infrastructures/new';
      preLoaderRoute: typeof TenantResourcesInfrastructuresNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/resources/instance-types/': {
      id: '/$tenant/resources/instance-types/';
      path: '/resources/instance-types';
      fullPath: '/$tenant/resources/instance-types/';
      preLoaderRoute: typeof TenantResourcesInstanceTypesIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/resources/instance-types/$instanceTypeId': {
      id: '/$tenant/resources/instance-types/$instanceTypeId';
      path: '/resources/instance-types/$instanceTypeId';
      fullPath: '/$tenant/resources/instance-types/$instanceTypeId';
      preLoaderRoute: typeof TenantResourcesInstanceTypesInstanceTypeIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/resources/quotas/': {
      id: '/$tenant/resources/quotas/';
      path: '/resources/quotas';
      fullPath: '/$tenant/resources/quotas/';
      preLoaderRoute: typeof TenantResourcesQuotasIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/resources/quotas/$quotaKey': {
      id: '/$tenant/resources/quotas/$quotaKey';
      path: '/resources/quotas/$quotaKey';
      fullPath: '/$tenant/resources/quotas/$quotaKey';
      preLoaderRoute: typeof TenantResourcesQuotasQuotaKeyRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/runtimes/$runtimeId/': {
      id: '/$tenant/runtimes/$runtimeId/';
      path: '/runtimes/$runtimeId';
      fullPath: '/$tenant/runtimes/$runtimeId/';
      preLoaderRoute: typeof TenantRuntimesRuntimeIdIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/sql/$warehouseId/': {
      id: '/$tenant/sql/$warehouseId/';
      path: '/sql/$warehouseId';
      fullPath: '/$tenant/sql/$warehouseId/';
      preLoaderRoute: typeof TenantSqlWarehouseIdIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/sql/$warehouseId/query': {
      id: '/$tenant/sql/$warehouseId/query';
      path: '/sql/$warehouseId/query';
      fullPath: '/$tenant/sql/$warehouseId/query';
      preLoaderRoute: typeof TenantSqlWarehouseIdQueryRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/tokens/agents/$identityId': {
      id: '/$tenant/tokens/agents/$identityId';
      path: '/tokens/agents/$identityId';
      fullPath: '/$tenant/tokens/agents/$identityId';
      preLoaderRoute: typeof TenantTokensAgentsIdentityIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/tokens/api/$applicationId': {
      id: '/$tenant/tokens/api/$applicationId';
      path: '/tokens/api/$applicationId';
      fullPath: '/$tenant/tokens/api/$applicationId';
      preLoaderRoute: typeof TenantTokensApiApplicationIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/catalog/$layer/$database/': {
      id: '/$tenant/catalog/$layer/$database/';
      path: '/catalog/$layer/$database';
      fullPath: '/$tenant/catalog/$layer/$database/';
      preLoaderRoute: typeof TenantCatalogLayerDatabaseIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/catalog/$layer/$database/new': {
      id: '/$tenant/catalog/$layer/$database/new';
      path: '/catalog/$layer/$database/new';
      fullPath: '/$tenant/catalog/$layer/$database/new';
      preLoaderRoute: typeof TenantCatalogLayerDatabaseNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/jobs/$jobId/runs/$runId': {
      id: '/$tenant/jobs/$jobId/runs/$runId';
      path: '/jobs/$jobId/runs/$runId';
      fullPath: '/$tenant/jobs/$jobId/runs/$runId';
      preLoaderRoute: typeof TenantJobsJobIdRunsRunIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/models/$modelId/versions/$versionId': {
      id: '/$tenant/models/$modelId/versions/$versionId';
      path: '/models/$modelId/versions/$versionId';
      fullPath: '/$tenant/models/$modelId/versions/$versionId';
      preLoaderRoute: typeof TenantModelsModelIdVersionsVersionIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/models/$modelId/versions/new': {
      id: '/$tenant/models/$modelId/versions/new';
      path: '/models/$modelId/versions/new';
      fullPath: '/$tenant/models/$modelId/versions/new';
      preLoaderRoute: typeof TenantModelsModelIdVersionsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/approvals/$approvalId': {
      id: '/$tenant/projects/$projectId/approvals/$approvalId';
      path: '/projects/$projectId/approvals/$approvalId';
      fullPath: '/$tenant/projects/$projectId/approvals/$approvalId';
      preLoaderRoute: typeof TenantProjectsProjectIdApprovalsApprovalIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/assistant/': {
      id: '/$tenant/projects/$projectId/assistant/';
      path: '/projects/$projectId/assistant';
      fullPath: '/$tenant/projects/$projectId/assistant/';
      preLoaderRoute: typeof TenantProjectsProjectIdAssistantIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/assistant/$indexId': {
      id: '/$tenant/projects/$projectId/assistant/$indexId';
      path: '/projects/$projectId/assistant/$indexId';
      fullPath: '/$tenant/projects/$projectId/assistant/$indexId';
      preLoaderRoute: typeof TenantProjectsProjectIdAssistantIndexIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/assistant/new': {
      id: '/$tenant/projects/$projectId/assistant/new';
      path: '/projects/$projectId/assistant/new';
      fullPath: '/$tenant/projects/$projectId/assistant/new';
      preLoaderRoute: typeof TenantProjectsProjectIdAssistantNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/connections/': {
      id: '/$tenant/projects/$projectId/connections/';
      path: '/projects/$projectId/connections';
      fullPath: '/$tenant/projects/$projectId/connections/';
      preLoaderRoute: typeof TenantProjectsProjectIdConnectionsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/connections/$connectionId': {
      id: '/$tenant/projects/$projectId/connections/$connectionId';
      path: '/projects/$projectId/connections/$connectionId';
      fullPath: '/$tenant/projects/$projectId/connections/$connectionId';
      preLoaderRoute: typeof TenantProjectsProjectIdConnectionsConnectionIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/connections/new': {
      id: '/$tenant/projects/$projectId/connections/new';
      path: '/projects/$projectId/connections/new';
      fullPath: '/$tenant/projects/$projectId/connections/new';
      preLoaderRoute: typeof TenantProjectsProjectIdConnectionsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/endpoints/': {
      id: '/$tenant/projects/$projectId/endpoints/';
      path: '/projects/$projectId/endpoints';
      fullPath: '/$tenant/projects/$projectId/endpoints/';
      preLoaderRoute: typeof TenantProjectsProjectIdEndpointsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/endpoints/$endpointId': {
      id: '/$tenant/projects/$projectId/endpoints/$endpointId';
      path: '/projects/$projectId/endpoints/$endpointId';
      fullPath: '/$tenant/projects/$projectId/endpoints/$endpointId';
      preLoaderRoute: typeof TenantProjectsProjectIdEndpointsEndpointIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/endpoints/new': {
      id: '/$tenant/projects/$projectId/endpoints/new';
      path: '/projects/$projectId/endpoints/new';
      fullPath: '/$tenant/projects/$projectId/endpoints/new';
      preLoaderRoute: typeof TenantProjectsProjectIdEndpointsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/experiments/': {
      id: '/$tenant/projects/$projectId/experiments/';
      path: '/projects/$projectId/experiments';
      fullPath: '/$tenant/projects/$projectId/experiments/';
      preLoaderRoute: typeof TenantProjectsProjectIdExperimentsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/experiments/new': {
      id: '/$tenant/projects/$projectId/experiments/new';
      path: '/projects/$projectId/experiments/new';
      fullPath: '/$tenant/projects/$projectId/experiments/new';
      preLoaderRoute: typeof TenantProjectsProjectIdExperimentsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/jobs/': {
      id: '/$tenant/projects/$projectId/jobs/';
      path: '/projects/$projectId/jobs';
      fullPath: '/$tenant/projects/$projectId/jobs/';
      preLoaderRoute: typeof TenantProjectsProjectIdJobsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/jobs/new': {
      id: '/$tenant/projects/$projectId/jobs/new';
      path: '/projects/$projectId/jobs/new';
      fullPath: '/$tenant/projects/$projectId/jobs/new';
      preLoaderRoute: typeof TenantProjectsProjectIdJobsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/members/': {
      id: '/$tenant/projects/$projectId/members/';
      path: '/projects/$projectId/members';
      fullPath: '/$tenant/projects/$projectId/members/';
      preLoaderRoute: typeof TenantProjectsProjectIdMembersIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/members/new': {
      id: '/$tenant/projects/$projectId/members/new';
      path: '/projects/$projectId/members/new';
      fullPath: '/$tenant/projects/$projectId/members/new';
      preLoaderRoute: typeof TenantProjectsProjectIdMembersNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/triggers/': {
      id: '/$tenant/projects/$projectId/triggers/';
      path: '/projects/$projectId/triggers';
      fullPath: '/$tenant/projects/$projectId/triggers/';
      preLoaderRoute: typeof TenantProjectsProjectIdTriggersIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/workflows/': {
      id: '/$tenant/projects/$projectId/workflows/';
      path: '/projects/$projectId/workflows';
      fullPath: '/$tenant/projects/$projectId/workflows/';
      preLoaderRoute: typeof TenantProjectsProjectIdWorkflowsIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/workflows/editor': {
      id: '/$tenant/projects/$projectId/workflows/editor';
      path: '/projects/$projectId/workflows/editor';
      fullPath: '/$tenant/projects/$projectId/workflows/editor';
      preLoaderRoute: typeof TenantProjectsProjectIdWorkflowsEditorRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/workflows/import-oozie': {
      id: '/$tenant/projects/$projectId/workflows/import-oozie';
      path: '/projects/$projectId/workflows/import-oozie';
      fullPath: '/$tenant/projects/$projectId/workflows/import-oozie';
      preLoaderRoute: typeof TenantProjectsProjectIdWorkflowsImportOozieRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/workflows/new': {
      id: '/$tenant/projects/$projectId/workflows/new';
      path: '/projects/$projectId/workflows/new';
      fullPath: '/$tenant/projects/$projectId/workflows/new';
      preLoaderRoute: typeof TenantProjectsProjectIdWorkflowsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/runtimes/$runtimeId/builds/$buildId': {
      id: '/$tenant/runtimes/$runtimeId/builds/$buildId';
      path: '/runtimes/$runtimeId/builds/$buildId';
      fullPath: '/$tenant/runtimes/$runtimeId/builds/$buildId';
      preLoaderRoute: typeof TenantRuntimesRuntimeIdBuildsBuildIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/runtimes/$runtimeId/builds/new': {
      id: '/$tenant/runtimes/$runtimeId/builds/new';
      path: '/runtimes/$runtimeId/builds/new';
      fullPath: '/$tenant/runtimes/$runtimeId/builds/new';
      preLoaderRoute: typeof TenantRuntimesRuntimeIdBuildsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/runtimes/$runtimeId/versions/$versionId': {
      id: '/$tenant/runtimes/$runtimeId/versions/$versionId';
      path: '/runtimes/$runtimeId/versions/$versionId';
      fullPath: '/$tenant/runtimes/$runtimeId/versions/$versionId';
      preLoaderRoute: typeof TenantRuntimesRuntimeIdVersionsVersionIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/runtimes/$runtimeId/versions/new': {
      id: '/$tenant/runtimes/$runtimeId/versions/new';
      path: '/runtimes/$runtimeId/versions/new';
      fullPath: '/$tenant/runtimes/$runtimeId/versions/new';
      preLoaderRoute: typeof TenantRuntimesRuntimeIdVersionsNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/catalog/$layer/$database/$table/': {
      id: '/$tenant/catalog/$layer/$database/$table/';
      path: '/catalog/$layer/$database/$table';
      fullPath: '/$tenant/catalog/$layer/$database/$table/';
      preLoaderRoute: typeof TenantCatalogLayerDatabaseTableIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/catalog/$layer/$database/$table/$field': {
      id: '/$tenant/catalog/$layer/$database/$table/$field';
      path: '/catalog/$layer/$database/$table/$field';
      fullPath: '/$tenant/catalog/$layer/$database/$table/$field';
      preLoaderRoute: typeof TenantCatalogLayerDatabaseTableFieldRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/catalog/$layer/$database/$table/new': {
      id: '/$tenant/catalog/$layer/$database/$table/new';
      path: '/catalog/$layer/$database/$table/new';
      fullPath: '/$tenant/catalog/$layer/$database/$table/new';
      preLoaderRoute: typeof TenantCatalogLayerDatabaseTableNewRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/experiments/$experimentId/': {
      id: '/$tenant/projects/$projectId/experiments/$experimentId/';
      path: '/projects/$projectId/experiments/$experimentId';
      fullPath: '/$tenant/projects/$projectId/experiments/$experimentId/';
      preLoaderRoute: typeof TenantProjectsProjectIdExperimentsExperimentIdIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/experiments/$experimentId/compare': {
      id: '/$tenant/projects/$projectId/experiments/$experimentId/compare';
      path: '/projects/$projectId/experiments/$experimentId/compare';
      fullPath: '/$tenant/projects/$projectId/experiments/$experimentId/compare';
      preLoaderRoute: typeof TenantProjectsProjectIdExperimentsExperimentIdCompareRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/jobs/$jobId/': {
      id: '/$tenant/projects/$projectId/jobs/$jobId/';
      path: '/projects/$projectId/jobs/$jobId';
      fullPath: '/$tenant/projects/$projectId/jobs/$jobId/';
      preLoaderRoute: typeof TenantProjectsProjectIdJobsJobIdIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/workflows/$workflowId/': {
      id: '/$tenant/projects/$projectId/workflows/$workflowId/';
      path: '/projects/$projectId/workflows/$workflowId';
      fullPath: '/$tenant/projects/$projectId/workflows/$workflowId/';
      preLoaderRoute: typeof TenantProjectsProjectIdWorkflowsWorkflowIdIndexRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/workflows/$workflowId/editor': {
      id: '/$tenant/projects/$projectId/workflows/$workflowId/editor';
      path: '/projects/$projectId/workflows/$workflowId/editor';
      fullPath: '/$tenant/projects/$projectId/workflows/$workflowId/editor';
      preLoaderRoute: typeof TenantProjectsProjectIdWorkflowsWorkflowIdEditorRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/experiments/$experimentId/runs/$runId': {
      id: '/$tenant/projects/$projectId/experiments/$experimentId/runs/$runId';
      path: '/projects/$projectId/experiments/$experimentId/runs/$runId';
      fullPath: '/$tenant/projects/$projectId/experiments/$experimentId/runs/$runId';
      preLoaderRoute: typeof TenantProjectsProjectIdExperimentsExperimentIdRunsRunIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/jobs/$jobId/runs/$runId': {
      id: '/$tenant/projects/$projectId/jobs/$jobId/runs/$runId';
      path: '/projects/$projectId/jobs/$jobId/runs/$runId';
      fullPath: '/$tenant/projects/$projectId/jobs/$jobId/runs/$runId';
      preLoaderRoute: typeof TenantProjectsProjectIdJobsJobIdRunsRunIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
    '/$tenant/projects/$projectId/workflows/$workflowId/runs/$runId': {
      id: '/$tenant/projects/$projectId/workflows/$workflowId/runs/$runId';
      path: '/projects/$projectId/workflows/$workflowId/runs/$runId';
      fullPath: '/$tenant/projects/$projectId/workflows/$workflowId/runs/$runId';
      preLoaderRoute: typeof TenantProjectsProjectIdWorkflowsWorkflowIdRunsRunIdRouteImport;
      parentRoute: typeof TenantRoute;
    };
  }
}

interface TenantRouteChildren {
  TenantAgentsRoute: typeof TenantAgentsRoute;
  TenantApiDocsRoute: typeof TenantApiDocsRoute;
  TenantAssistantRoute: typeof TenantAssistantRoute;
  TenantAuditRoute: typeof TenantAuditRoute;
  TenantAuditTrailRoute: typeof TenantAuditTrailRoute;
  TenantBrandingRoute: typeof TenantBrandingRoute;
  TenantCodeAssistantRoute: typeof TenantCodeAssistantRoute;
  TenantJupyterRoute: typeof TenantJupyterRoute;
  TenantLlmKeysRoute: typeof TenantLlmKeysRoute;
  TenantMeRoute: typeof TenantMeRoute;
  TenantMfaRoute: typeof TenantMfaRoute;
  TenantNotificationsRoute: typeof TenantNotificationsRoute;
  TenantOverviewRoute: typeof TenantOverviewRoute;
  TenantPreferencesRoute: typeof TenantPreferencesRoute;
  TenantRstudioRoute: typeof TenantRstudioRoute;
  TenantSearchRoute: typeof TenantSearchRoute;
  TenantSecretStoreRoute: typeof TenantSecretStoreRoute;
  TenantSubscriptionRoute: typeof TenantSubscriptionRoute;
  TenantUsageRoute: typeof TenantUsageRoute;
  TenantVscodeRoute: typeof TenantVscodeRoute;
  TenantIndexRoute: typeof TenantIndexRoute;
  TenantAgentPoliciesPolicyIdRoute: typeof TenantAgentPoliciesPolicyIdRoute;
  TenantAgentPoliciesNewRoute: typeof TenantAgentPoliciesNewRoute;
  TenantBillingPricingRoute: typeof TenantBillingPricingRoute;
  TenantBridgesBridgeIdRoute: typeof TenantBridgesBridgeIdRoute;
  TenantBridgesNewRoute: typeof TenantBridgesNewRoute;
  TenantBucketsBucketIdRoute: typeof TenantBucketsBucketIdRoute;
  TenantBucketsNewRoute: typeof TenantBucketsNewRoute;
  TenantCatalogNewRoute: typeof TenantCatalogNewRoute;
  TenantEditorGraphIdRoute: typeof TenantEditorGraphIdRoute;
  TenantEditorNewRoute: typeof TenantEditorNewRoute;
  TenantFirewallRuleIdRoute: typeof TenantFirewallRuleIdRoute;
  TenantFirewallNewRoute: typeof TenantFirewallNewRoute;
  TenantGlossaryTermIdRoute: typeof TenantGlossaryTermIdRoute;
  TenantGlossaryNewRoute: typeof TenantGlossaryNewRoute;
  TenantGroupsGroupIdRoute: typeof TenantGroupsGroupIdRoute;
  TenantGroupsNewRoute: typeof TenantGroupsNewRoute;
  TenantIdentityProvidersIdentityProviderIdRoute: typeof TenantIdentityProvidersIdentityProviderIdRoute;
  TenantIdentityProvidersNewRoute: typeof TenantIdentityProvidersNewRoute;
  TenantLineageGraphRoute: typeof TenantLineageGraphRoute;
  TenantMembersUserIdRoute: typeof TenantMembersUserIdRoute;
  TenantMembersNewRoute: typeof TenantMembersNewRoute;
  TenantModelsNewRoute: typeof TenantModelsNewRoute;
  TenantProjectsNewRoute: typeof TenantProjectsNewRoute;
  TenantRolesRoleIdRoute: typeof TenantRolesRoleIdRoute;
  TenantRolesAssignmentsRoute: typeof TenantRolesAssignmentsRoute;
  TenantRolesNewRoute: typeof TenantRolesNewRoute;
  TenantRuntimesNewRoute: typeof TenantRuntimesNewRoute;
  TenantSecretsSecretIdRoute: typeof TenantSecretsSecretIdRoute;
  TenantSecretsNewRoute: typeof TenantSecretsNewRoute;
  TenantSessionsSessionIdRoute: typeof TenantSessionsSessionIdRoute;
  TenantSessionsNewRoute: typeof TenantSessionsNewRoute;
  TenantSqlNewRoute: typeof TenantSqlNewRoute;
  TenantStreamsStreamIdRoute: typeof TenantStreamsStreamIdRoute;
  TenantStreamsNewRoute: typeof TenantStreamsNewRoute;
  TenantSupportTicketIdRoute: typeof TenantSupportTicketIdRoute;
  TenantSupportNewRoute: typeof TenantSupportNewRoute;
  TenantTokensNewRoute: typeof TenantTokensNewRoute;
  TenantWorkflowsEditorRoute: typeof TenantWorkflowsEditorRoute;
  TenantWorkspacesWorkspaceIdRoute: typeof TenantWorkspacesWorkspaceIdRoute;
  TenantWorkspacesNewRoute: typeof TenantWorkspacesNewRoute;
  TenantAgentPoliciesIndexRoute: typeof TenantAgentPoliciesIndexRoute;
  TenantBillingIndexRoute: typeof TenantBillingIndexRoute;
  TenantBridgesIndexRoute: typeof TenantBridgesIndexRoute;
  TenantBucketsIndexRoute: typeof TenantBucketsIndexRoute;
  TenantCatalogIndexRoute: typeof TenantCatalogIndexRoute;
  TenantConnectionsIndexRoute: typeof TenantConnectionsIndexRoute;
  TenantEditorIndexRoute: typeof TenantEditorIndexRoute;
  TenantEndpointsIndexRoute: typeof TenantEndpointsIndexRoute;
  TenantExperimentsIndexRoute: typeof TenantExperimentsIndexRoute;
  TenantFirewallIndexRoute: typeof TenantFirewallIndexRoute;
  TenantGlossaryIndexRoute: typeof TenantGlossaryIndexRoute;
  TenantGroupsIndexRoute: typeof TenantGroupsIndexRoute;
  TenantIdentityProvidersIndexRoute: typeof TenantIdentityProvidersIndexRoute;
  TenantJobsIndexRoute: typeof TenantJobsIndexRoute;
  TenantLibrariesIndexRoute: typeof TenantLibrariesIndexRoute;
  TenantLineageIndexRoute: typeof TenantLineageIndexRoute;
  TenantLlmIndexRoute: typeof TenantLlmIndexRoute;
  TenantMembersIndexRoute: typeof TenantMembersIndexRoute;
  TenantModelsIndexRoute: typeof TenantModelsIndexRoute;
  TenantProjectsIndexRoute: typeof TenantProjectsIndexRoute;
  TenantRolesIndexRoute: typeof TenantRolesIndexRoute;
  TenantRuntimesIndexRoute: typeof TenantRuntimesIndexRoute;
  TenantSecretsIndexRoute: typeof TenantSecretsIndexRoute;
  TenantSessionsIndexRoute: typeof TenantSessionsIndexRoute;
  TenantSqlIndexRoute: typeof TenantSqlIndexRoute;
  TenantStreamsIndexRoute: typeof TenantStreamsIndexRoute;
  TenantSupportIndexRoute: typeof TenantSupportIndexRoute;
  TenantTokensIndexRoute: typeof TenantTokensIndexRoute;
  TenantTriggersIndexRoute: typeof TenantTriggersIndexRoute;
  TenantWorkflowsIndexRoute: typeof TenantWorkflowsIndexRoute;
  TenantWorkspacesIndexRoute: typeof TenantWorkspacesIndexRoute;
  TenantBillingInvoicesInvoiceIdRoute: typeof TenantBillingInvoicesInvoiceIdRoute;
  TenantBillingPaymentMethodsNewRoute: typeof TenantBillingPaymentMethodsNewRoute;
  TenantBillingTransactionsTransactionIdRoute: typeof TenantBillingTransactionsTransactionIdRoute;
  TenantCatalogLayerNewRoute: typeof TenantCatalogLayerNewRoute;
  TenantEditorTemplatesTemplateNameRoute: typeof TenantEditorTemplatesTemplateNameRoute;
  TenantLlmBudgetsProjectIdRoute: typeof TenantLlmBudgetsProjectIdRoute;
  TenantLlmModelsModelIdRoute: typeof TenantLlmModelsModelIdRoute;
  TenantLlmModelsNewRoute: typeof TenantLlmModelsNewRoute;
  TenantLlmProvidersProviderIdRoute: typeof TenantLlmProvidersProviderIdRoute;
  TenantLlmProvidersNewRoute: typeof TenantLlmProvidersNewRoute;
  TenantProjectsProjectIdActivityRoute: typeof TenantProjectsProjectIdActivityRoute;
  TenantProjectsProjectIdAgentsRoute: typeof TenantProjectsProjectIdAgentsRoute;
  TenantProjectsProjectIdCodeAssistantRoute: typeof TenantProjectsProjectIdCodeAssistantRoute;
  TenantProjectsProjectIdCostsRoute: typeof TenantProjectsProjectIdCostsRoute;
  TenantProjectsProjectIdLlmKeysRoute: typeof TenantProjectsProjectIdLlmKeysRoute;
  TenantProjectsProjectIdMetricsRoute: typeof TenantProjectsProjectIdMetricsRoute;
  TenantProjectsProjectIdSettingsRoute: typeof TenantProjectsProjectIdSettingsRoute;
  TenantResourcesDevicesDeviceIdRoute: typeof TenantResourcesDevicesDeviceIdRoute;
  TenantResourcesDevicesEnrollRoute: typeof TenantResourcesDevicesEnrollRoute;
  TenantResourcesInfrastructuresInfrastructureIdRoute: typeof TenantResourcesInfrastructuresInfrastructureIdRoute;
  TenantResourcesInfrastructuresNewRoute: typeof TenantResourcesInfrastructuresNewRoute;
  TenantResourcesInstanceTypesInstanceTypeIdRoute: typeof TenantResourcesInstanceTypesInstanceTypeIdRoute;
  TenantResourcesQuotasQuotaKeyRoute: typeof TenantResourcesQuotasQuotaKeyRoute;
  TenantSqlWarehouseIdQueryRoute: typeof TenantSqlWarehouseIdQueryRoute;
  TenantTokensAgentsIdentityIdRoute: typeof TenantTokensAgentsIdentityIdRoute;
  TenantTokensApiApplicationIdRoute: typeof TenantTokensApiApplicationIdRoute;
  TenantBillingInvoicesIndexRoute: typeof TenantBillingInvoicesIndexRoute;
  TenantBillingPaymentMethodsIndexRoute: typeof TenantBillingPaymentMethodsIndexRoute;
  TenantBillingTransactionsIndexRoute: typeof TenantBillingTransactionsIndexRoute;
  TenantCatalogLayerIndexRoute: typeof TenantCatalogLayerIndexRoute;
  TenantEditorTemplatesIndexRoute: typeof TenantEditorTemplatesIndexRoute;
  TenantModelsModelIdIndexRoute: typeof TenantModelsModelIdIndexRoute;
  TenantProjectsProjectIdIndexRoute: typeof TenantProjectsProjectIdIndexRoute;
  TenantResourcesDevicesIndexRoute: typeof TenantResourcesDevicesIndexRoute;
  TenantResourcesInfrastructuresIndexRoute: typeof TenantResourcesInfrastructuresIndexRoute;
  TenantResourcesInstanceTypesIndexRoute: typeof TenantResourcesInstanceTypesIndexRoute;
  TenantResourcesQuotasIndexRoute: typeof TenantResourcesQuotasIndexRoute;
  TenantRuntimesRuntimeIdIndexRoute: typeof TenantRuntimesRuntimeIdIndexRoute;
  TenantSqlWarehouseIdIndexRoute: typeof TenantSqlWarehouseIdIndexRoute;
  TenantCatalogLayerDatabaseNewRoute: typeof TenantCatalogLayerDatabaseNewRoute;
  TenantJobsJobIdRunsRunIdRoute: typeof TenantJobsJobIdRunsRunIdRoute;
  TenantModelsModelIdVersionsVersionIdRoute: typeof TenantModelsModelIdVersionsVersionIdRoute;
  TenantModelsModelIdVersionsNewRoute: typeof TenantModelsModelIdVersionsNewRoute;
  TenantProjectsProjectIdApprovalsApprovalIdRoute: typeof TenantProjectsProjectIdApprovalsApprovalIdRoute;
  TenantProjectsProjectIdAssistantIndexIdRoute: typeof TenantProjectsProjectIdAssistantIndexIdRoute;
  TenantProjectsProjectIdAssistantNewRoute: typeof TenantProjectsProjectIdAssistantNewRoute;
  TenantProjectsProjectIdConnectionsConnectionIdRoute: typeof TenantProjectsProjectIdConnectionsConnectionIdRoute;
  TenantProjectsProjectIdConnectionsNewRoute: typeof TenantProjectsProjectIdConnectionsNewRoute;
  TenantProjectsProjectIdEndpointsEndpointIdRoute: typeof TenantProjectsProjectIdEndpointsEndpointIdRoute;
  TenantProjectsProjectIdEndpointsNewRoute: typeof TenantProjectsProjectIdEndpointsNewRoute;
  TenantProjectsProjectIdExperimentsNewRoute: typeof TenantProjectsProjectIdExperimentsNewRoute;
  TenantProjectsProjectIdJobsNewRoute: typeof TenantProjectsProjectIdJobsNewRoute;
  TenantProjectsProjectIdMembersNewRoute: typeof TenantProjectsProjectIdMembersNewRoute;
  TenantProjectsProjectIdWorkflowsEditorRoute: typeof TenantProjectsProjectIdWorkflowsEditorRoute;
  TenantProjectsProjectIdWorkflowsImportOozieRoute: typeof TenantProjectsProjectIdWorkflowsImportOozieRoute;
  TenantProjectsProjectIdWorkflowsNewRoute: typeof TenantProjectsProjectIdWorkflowsNewRoute;
  TenantRuntimesRuntimeIdBuildsBuildIdRoute: typeof TenantRuntimesRuntimeIdBuildsBuildIdRoute;
  TenantRuntimesRuntimeIdBuildsNewRoute: typeof TenantRuntimesRuntimeIdBuildsNewRoute;
  TenantRuntimesRuntimeIdVersionsVersionIdRoute: typeof TenantRuntimesRuntimeIdVersionsVersionIdRoute;
  TenantRuntimesRuntimeIdVersionsNewRoute: typeof TenantRuntimesRuntimeIdVersionsNewRoute;
  TenantCatalogLayerDatabaseIndexRoute: typeof TenantCatalogLayerDatabaseIndexRoute;
  TenantProjectsProjectIdAssistantIndexRoute: typeof TenantProjectsProjectIdAssistantIndexRoute;
  TenantProjectsProjectIdConnectionsIndexRoute: typeof TenantProjectsProjectIdConnectionsIndexRoute;
  TenantProjectsProjectIdEndpointsIndexRoute: typeof TenantProjectsProjectIdEndpointsIndexRoute;
  TenantProjectsProjectIdExperimentsIndexRoute: typeof TenantProjectsProjectIdExperimentsIndexRoute;
  TenantProjectsProjectIdJobsIndexRoute: typeof TenantProjectsProjectIdJobsIndexRoute;
  TenantProjectsProjectIdMembersIndexRoute: typeof TenantProjectsProjectIdMembersIndexRoute;
  TenantProjectsProjectIdTriggersIndexRoute: typeof TenantProjectsProjectIdTriggersIndexRoute;
  TenantProjectsProjectIdWorkflowsIndexRoute: typeof TenantProjectsProjectIdWorkflowsIndexRoute;
  TenantCatalogLayerDatabaseTableFieldRoute: typeof TenantCatalogLayerDatabaseTableFieldRoute;
  TenantCatalogLayerDatabaseTableNewRoute: typeof TenantCatalogLayerDatabaseTableNewRoute;
  TenantProjectsProjectIdExperimentsExperimentIdCompareRoute: typeof TenantProjectsProjectIdExperimentsExperimentIdCompareRoute;
  TenantProjectsProjectIdWorkflowsWorkflowIdEditorRoute: typeof TenantProjectsProjectIdWorkflowsWorkflowIdEditorRoute;
  TenantCatalogLayerDatabaseTableIndexRoute: typeof TenantCatalogLayerDatabaseTableIndexRoute;
  TenantProjectsProjectIdExperimentsExperimentIdIndexRoute: typeof TenantProjectsProjectIdExperimentsExperimentIdIndexRoute;
  TenantProjectsProjectIdJobsJobIdIndexRoute: typeof TenantProjectsProjectIdJobsJobIdIndexRoute;
  TenantProjectsProjectIdWorkflowsWorkflowIdIndexRoute: typeof TenantProjectsProjectIdWorkflowsWorkflowIdIndexRoute;
  TenantProjectsProjectIdExperimentsExperimentIdRunsRunIdRoute: typeof TenantProjectsProjectIdExperimentsExperimentIdRunsRunIdRoute;
  TenantProjectsProjectIdJobsJobIdRunsRunIdRoute: typeof TenantProjectsProjectIdJobsJobIdRunsRunIdRoute;
  TenantProjectsProjectIdWorkflowsWorkflowIdRunsRunIdRoute: typeof TenantProjectsProjectIdWorkflowsWorkflowIdRunsRunIdRoute;
}

const TenantRouteChildren: TenantRouteChildren = {
  TenantAgentsRoute: TenantAgentsRoute,
  TenantApiDocsRoute: TenantApiDocsRoute,
  TenantAssistantRoute: TenantAssistantRoute,
  TenantAuditRoute: TenantAuditRoute,
  TenantAuditTrailRoute: TenantAuditTrailRoute,
  TenantBrandingRoute: TenantBrandingRoute,
  TenantCodeAssistantRoute: TenantCodeAssistantRoute,
  TenantJupyterRoute: TenantJupyterRoute,
  TenantLlmKeysRoute: TenantLlmKeysRoute,
  TenantMeRoute: TenantMeRoute,
  TenantMfaRoute: TenantMfaRoute,
  TenantNotificationsRoute: TenantNotificationsRoute,
  TenantOverviewRoute: TenantOverviewRoute,
  TenantPreferencesRoute: TenantPreferencesRoute,
  TenantRstudioRoute: TenantRstudioRoute,
  TenantSearchRoute: TenantSearchRoute,
  TenantSecretStoreRoute: TenantSecretStoreRoute,
  TenantSubscriptionRoute: TenantSubscriptionRoute,
  TenantUsageRoute: TenantUsageRoute,
  TenantVscodeRoute: TenantVscodeRoute,
  TenantIndexRoute: TenantIndexRoute,
  TenantAgentPoliciesPolicyIdRoute: TenantAgentPoliciesPolicyIdRoute,
  TenantAgentPoliciesNewRoute: TenantAgentPoliciesNewRoute,
  TenantBillingPricingRoute: TenantBillingPricingRoute,
  TenantBridgesBridgeIdRoute: TenantBridgesBridgeIdRoute,
  TenantBridgesNewRoute: TenantBridgesNewRoute,
  TenantBucketsBucketIdRoute: TenantBucketsBucketIdRoute,
  TenantBucketsNewRoute: TenantBucketsNewRoute,
  TenantCatalogNewRoute: TenantCatalogNewRoute,
  TenantEditorGraphIdRoute: TenantEditorGraphIdRoute,
  TenantEditorNewRoute: TenantEditorNewRoute,
  TenantFirewallRuleIdRoute: TenantFirewallRuleIdRoute,
  TenantFirewallNewRoute: TenantFirewallNewRoute,
  TenantGlossaryTermIdRoute: TenantGlossaryTermIdRoute,
  TenantGlossaryNewRoute: TenantGlossaryNewRoute,
  TenantGroupsGroupIdRoute: TenantGroupsGroupIdRoute,
  TenantGroupsNewRoute: TenantGroupsNewRoute,
  TenantIdentityProvidersIdentityProviderIdRoute:
    TenantIdentityProvidersIdentityProviderIdRoute,
  TenantIdentityProvidersNewRoute: TenantIdentityProvidersNewRoute,
  TenantLineageGraphRoute: TenantLineageGraphRoute,
  TenantMembersUserIdRoute: TenantMembersUserIdRoute,
  TenantMembersNewRoute: TenantMembersNewRoute,
  TenantModelsNewRoute: TenantModelsNewRoute,
  TenantProjectsNewRoute: TenantProjectsNewRoute,
  TenantRolesRoleIdRoute: TenantRolesRoleIdRoute,
  TenantRolesAssignmentsRoute: TenantRolesAssignmentsRoute,
  TenantRolesNewRoute: TenantRolesNewRoute,
  TenantRuntimesNewRoute: TenantRuntimesNewRoute,
  TenantSecretsSecretIdRoute: TenantSecretsSecretIdRoute,
  TenantSecretsNewRoute: TenantSecretsNewRoute,
  TenantSessionsSessionIdRoute: TenantSessionsSessionIdRoute,
  TenantSessionsNewRoute: TenantSessionsNewRoute,
  TenantSqlNewRoute: TenantSqlNewRoute,
  TenantStreamsStreamIdRoute: TenantStreamsStreamIdRoute,
  TenantStreamsNewRoute: TenantStreamsNewRoute,
  TenantSupportTicketIdRoute: TenantSupportTicketIdRoute,
  TenantSupportNewRoute: TenantSupportNewRoute,
  TenantTokensNewRoute: TenantTokensNewRoute,
  TenantWorkflowsEditorRoute: TenantWorkflowsEditorRoute,
  TenantWorkspacesWorkspaceIdRoute: TenantWorkspacesWorkspaceIdRoute,
  TenantWorkspacesNewRoute: TenantWorkspacesNewRoute,
  TenantAgentPoliciesIndexRoute: TenantAgentPoliciesIndexRoute,
  TenantBillingIndexRoute: TenantBillingIndexRoute,
  TenantBridgesIndexRoute: TenantBridgesIndexRoute,
  TenantBucketsIndexRoute: TenantBucketsIndexRoute,
  TenantCatalogIndexRoute: TenantCatalogIndexRoute,
  TenantConnectionsIndexRoute: TenantConnectionsIndexRoute,
  TenantEditorIndexRoute: TenantEditorIndexRoute,
  TenantEndpointsIndexRoute: TenantEndpointsIndexRoute,
  TenantExperimentsIndexRoute: TenantExperimentsIndexRoute,
  TenantFirewallIndexRoute: TenantFirewallIndexRoute,
  TenantGlossaryIndexRoute: TenantGlossaryIndexRoute,
  TenantGroupsIndexRoute: TenantGroupsIndexRoute,
  TenantIdentityProvidersIndexRoute: TenantIdentityProvidersIndexRoute,
  TenantJobsIndexRoute: TenantJobsIndexRoute,
  TenantLibrariesIndexRoute: TenantLibrariesIndexRoute,
  TenantLineageIndexRoute: TenantLineageIndexRoute,
  TenantLlmIndexRoute: TenantLlmIndexRoute,
  TenantMembersIndexRoute: TenantMembersIndexRoute,
  TenantModelsIndexRoute: TenantModelsIndexRoute,
  TenantProjectsIndexRoute: TenantProjectsIndexRoute,
  TenantRolesIndexRoute: TenantRolesIndexRoute,
  TenantRuntimesIndexRoute: TenantRuntimesIndexRoute,
  TenantSecretsIndexRoute: TenantSecretsIndexRoute,
  TenantSessionsIndexRoute: TenantSessionsIndexRoute,
  TenantSqlIndexRoute: TenantSqlIndexRoute,
  TenantStreamsIndexRoute: TenantStreamsIndexRoute,
  TenantSupportIndexRoute: TenantSupportIndexRoute,
  TenantTokensIndexRoute: TenantTokensIndexRoute,
  TenantTriggersIndexRoute: TenantTriggersIndexRoute,
  TenantWorkflowsIndexRoute: TenantWorkflowsIndexRoute,
  TenantWorkspacesIndexRoute: TenantWorkspacesIndexRoute,
  TenantBillingInvoicesInvoiceIdRoute: TenantBillingInvoicesInvoiceIdRoute,
  TenantBillingPaymentMethodsNewRoute: TenantBillingPaymentMethodsNewRoute,
  TenantBillingTransactionsTransactionIdRoute:
    TenantBillingTransactionsTransactionIdRoute,
  TenantCatalogLayerNewRoute: TenantCatalogLayerNewRoute,
  TenantEditorTemplatesTemplateNameRoute:
    TenantEditorTemplatesTemplateNameRoute,
  TenantLlmBudgetsProjectIdRoute: TenantLlmBudgetsProjectIdRoute,
  TenantLlmModelsModelIdRoute: TenantLlmModelsModelIdRoute,
  TenantLlmModelsNewRoute: TenantLlmModelsNewRoute,
  TenantLlmProvidersProviderIdRoute: TenantLlmProvidersProviderIdRoute,
  TenantLlmProvidersNewRoute: TenantLlmProvidersNewRoute,
  TenantProjectsProjectIdActivityRoute: TenantProjectsProjectIdActivityRoute,
  TenantProjectsProjectIdAgentsRoute: TenantProjectsProjectIdAgentsRoute,
  TenantProjectsProjectIdCodeAssistantRoute:
    TenantProjectsProjectIdCodeAssistantRoute,
  TenantProjectsProjectIdCostsRoute: TenantProjectsProjectIdCostsRoute,
  TenantProjectsProjectIdLlmKeysRoute: TenantProjectsProjectIdLlmKeysRoute,
  TenantProjectsProjectIdMetricsRoute: TenantProjectsProjectIdMetricsRoute,
  TenantProjectsProjectIdSettingsRoute: TenantProjectsProjectIdSettingsRoute,
  TenantResourcesDevicesDeviceIdRoute: TenantResourcesDevicesDeviceIdRoute,
  TenantResourcesDevicesEnrollRoute: TenantResourcesDevicesEnrollRoute,
  TenantResourcesInfrastructuresInfrastructureIdRoute:
    TenantResourcesInfrastructuresInfrastructureIdRoute,
  TenantResourcesInfrastructuresNewRoute:
    TenantResourcesInfrastructuresNewRoute,
  TenantResourcesInstanceTypesInstanceTypeIdRoute:
    TenantResourcesInstanceTypesInstanceTypeIdRoute,
  TenantResourcesQuotasQuotaKeyRoute: TenantResourcesQuotasQuotaKeyRoute,
  TenantSqlWarehouseIdQueryRoute: TenantSqlWarehouseIdQueryRoute,
  TenantTokensAgentsIdentityIdRoute: TenantTokensAgentsIdentityIdRoute,
  TenantTokensApiApplicationIdRoute: TenantTokensApiApplicationIdRoute,
  TenantBillingInvoicesIndexRoute: TenantBillingInvoicesIndexRoute,
  TenantBillingPaymentMethodsIndexRoute: TenantBillingPaymentMethodsIndexRoute,
  TenantBillingTransactionsIndexRoute: TenantBillingTransactionsIndexRoute,
  TenantCatalogLayerIndexRoute: TenantCatalogLayerIndexRoute,
  TenantEditorTemplatesIndexRoute: TenantEditorTemplatesIndexRoute,
  TenantModelsModelIdIndexRoute: TenantModelsModelIdIndexRoute,
  TenantProjectsProjectIdIndexRoute: TenantProjectsProjectIdIndexRoute,
  TenantResourcesDevicesIndexRoute: TenantResourcesDevicesIndexRoute,
  TenantResourcesInfrastructuresIndexRoute:
    TenantResourcesInfrastructuresIndexRoute,
  TenantResourcesInstanceTypesIndexRoute:
    TenantResourcesInstanceTypesIndexRoute,
  TenantResourcesQuotasIndexRoute: TenantResourcesQuotasIndexRoute,
  TenantRuntimesRuntimeIdIndexRoute: TenantRuntimesRuntimeIdIndexRoute,
  TenantSqlWarehouseIdIndexRoute: TenantSqlWarehouseIdIndexRoute,
  TenantCatalogLayerDatabaseNewRoute: TenantCatalogLayerDatabaseNewRoute,
  TenantJobsJobIdRunsRunIdRoute: TenantJobsJobIdRunsRunIdRoute,
  TenantModelsModelIdVersionsVersionIdRoute:
    TenantModelsModelIdVersionsVersionIdRoute,
  TenantModelsModelIdVersionsNewRoute: TenantModelsModelIdVersionsNewRoute,
  TenantProjectsProjectIdApprovalsApprovalIdRoute:
    TenantProjectsProjectIdApprovalsApprovalIdRoute,
  TenantProjectsProjectIdAssistantIndexIdRoute:
    TenantProjectsProjectIdAssistantIndexIdRoute,
  TenantProjectsProjectIdAssistantNewRoute:
    TenantProjectsProjectIdAssistantNewRoute,
  TenantProjectsProjectIdConnectionsConnectionIdRoute:
    TenantProjectsProjectIdConnectionsConnectionIdRoute,
  TenantProjectsProjectIdConnectionsNewRoute:
    TenantProjectsProjectIdConnectionsNewRoute,
  TenantProjectsProjectIdEndpointsEndpointIdRoute:
    TenantProjectsProjectIdEndpointsEndpointIdRoute,
  TenantProjectsProjectIdEndpointsNewRoute:
    TenantProjectsProjectIdEndpointsNewRoute,
  TenantProjectsProjectIdExperimentsNewRoute:
    TenantProjectsProjectIdExperimentsNewRoute,
  TenantProjectsProjectIdJobsNewRoute: TenantProjectsProjectIdJobsNewRoute,
  TenantProjectsProjectIdMembersNewRoute:
    TenantProjectsProjectIdMembersNewRoute,
  TenantProjectsProjectIdWorkflowsEditorRoute:
    TenantProjectsProjectIdWorkflowsEditorRoute,
  TenantProjectsProjectIdWorkflowsImportOozieRoute:
    TenantProjectsProjectIdWorkflowsImportOozieRoute,
  TenantProjectsProjectIdWorkflowsNewRoute:
    TenantProjectsProjectIdWorkflowsNewRoute,
  TenantRuntimesRuntimeIdBuildsBuildIdRoute:
    TenantRuntimesRuntimeIdBuildsBuildIdRoute,
  TenantRuntimesRuntimeIdBuildsNewRoute: TenantRuntimesRuntimeIdBuildsNewRoute,
  TenantRuntimesRuntimeIdVersionsVersionIdRoute:
    TenantRuntimesRuntimeIdVersionsVersionIdRoute,
  TenantRuntimesRuntimeIdVersionsNewRoute:
    TenantRuntimesRuntimeIdVersionsNewRoute,
  TenantCatalogLayerDatabaseIndexRoute: TenantCatalogLayerDatabaseIndexRoute,
  TenantProjectsProjectIdAssistantIndexRoute:
    TenantProjectsProjectIdAssistantIndexRoute,
  TenantProjectsProjectIdConnectionsIndexRoute:
    TenantProjectsProjectIdConnectionsIndexRoute,
  TenantProjectsProjectIdEndpointsIndexRoute:
    TenantProjectsProjectIdEndpointsIndexRoute,
  TenantProjectsProjectIdExperimentsIndexRoute:
    TenantProjectsProjectIdExperimentsIndexRoute,
  TenantProjectsProjectIdJobsIndexRoute: TenantProjectsProjectIdJobsIndexRoute,
  TenantProjectsProjectIdMembersIndexRoute:
    TenantProjectsProjectIdMembersIndexRoute,
  TenantProjectsProjectIdTriggersIndexRoute:
    TenantProjectsProjectIdTriggersIndexRoute,
  TenantProjectsProjectIdWorkflowsIndexRoute:
    TenantProjectsProjectIdWorkflowsIndexRoute,
  TenantCatalogLayerDatabaseTableFieldRoute:
    TenantCatalogLayerDatabaseTableFieldRoute,
  TenantCatalogLayerDatabaseTableNewRoute:
    TenantCatalogLayerDatabaseTableNewRoute,
  TenantProjectsProjectIdExperimentsExperimentIdCompareRoute:
    TenantProjectsProjectIdExperimentsExperimentIdCompareRoute,
  TenantProjectsProjectIdWorkflowsWorkflowIdEditorRoute:
    TenantProjectsProjectIdWorkflowsWorkflowIdEditorRoute,
  TenantCatalogLayerDatabaseTableIndexRoute:
    TenantCatalogLayerDatabaseTableIndexRoute,
  TenantProjectsProjectIdExperimentsExperimentIdIndexRoute:
    TenantProjectsProjectIdExperimentsExperimentIdIndexRoute,
  TenantProjectsProjectIdJobsJobIdIndexRoute:
    TenantProjectsProjectIdJobsJobIdIndexRoute,
  TenantProjectsProjectIdWorkflowsWorkflowIdIndexRoute:
    TenantProjectsProjectIdWorkflowsWorkflowIdIndexRoute,
  TenantProjectsProjectIdExperimentsExperimentIdRunsRunIdRoute:
    TenantProjectsProjectIdExperimentsExperimentIdRunsRunIdRoute,
  TenantProjectsProjectIdJobsJobIdRunsRunIdRoute:
    TenantProjectsProjectIdJobsJobIdRunsRunIdRoute,
  TenantProjectsProjectIdWorkflowsWorkflowIdRunsRunIdRoute:
    TenantProjectsProjectIdWorkflowsWorkflowIdRunsRunIdRoute,
};

const TenantRouteWithChildren =
  TenantRoute._addFileChildren(TenantRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TenantRoute: TenantRouteWithChildren,
  CallbackRoute: CallbackRoute,
  LoginRoute: LoginRoute,
  SilentCallbackRoute: SilentCallbackRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
